<!-- spinning loader -->
<div class="overlay" *ngIf="isLoader">
  <div class="loader-center">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <!-- <img loading="lazy" class="loader1" src="assets/images/loader-gif.gif" alt="Your Image"> -->
    <ng-lottie [options]="lottieOptions" width="150px" height="150px"></ng-lottie>
  </div>
</div>
<!-- spinning loader -->

<app-accountheader
  [ngClass]="{'opacityClass':!showPopUp || showBonusListPopup || showBonusListPopup || withdrawPopup || withdrawCongoPopup ||bankLimitPopup || removePopup || showCongoPopup}"></app-accountheader>
<div class="dep-with-header max-width-550">
  <div class="left-side-dep-with-head">
    <button (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M13.1213 17.0759L6.25 10.2046L13.1213 3.33325L14.0833 4.31242L8.19115 10.2046L14.0833 16.0968L13.1213 17.0759Z"
          fill="#D71082" />
      </svg>
    </button>
    <span *ngIf="depositshowes == 'Deposit'" class="head-text-dep-with"> {{'Deposit'|translate}}
    </span>
    <span *ngIf="depositshowes == 'Withdraw'" class="head-text-dep-with"> {{'Withdraw'|translate}}
    </span>
  </div>
  <div (click)="openHowToDeposit()" *ngIf="depositshowes == 'Deposit'" class="right-side-dep-with-head">
    <span class="info-icon">
      <img src="../../../../../assets/images/video-logo.svg" alt="video">
    </span>
    <span class="dep-with-head-text-right">
      {{"How to Deposit"|translate}} ?
    </span>
  </div>
</div>
<div class="u-i-p-c-body-bc">
  <div class="top-fixed-stepper"
    [ngClass]="{'opacityClass':!showPopUp || showBonusListPopup || showBonusListPopup || withdrawPopup || withdrawCongoPopup || bankLimitPopup || removePopup || showCongoPopup}">
    <!-- <div class="hdr-navigation-scrollable-bc" data-scroll-lock-scrollable="">
      <div class="hdr-navigation-scrollable-content navPointer">
        <a [ngClass]="{'hdr-navigation-link-bc':true, 'active':istabactive==='Deposit'}"
          (click)="tabshow('Deposit')">Deposit</a>
        <a [ngClass]="{'hdr-navigation-link-bc':true, 'active':istabactive==='Withdraw'}"
          (click)="tabshow('Withdraw')">Withdraw</a>
        <a [ngClass]="{'hdr-navigation-link-bc':true, 'active':istabactive==='TransactionHistory'}"
          (click)="tabshow('TransactionHistory')">{{'account statement'|translate}}</a>
      </div>
    </div> -->
    <app-deposit-stepper *ngIf="depositshowes == 'Deposit'" [step]=stepperValue></app-deposit-stepper>
    <app-withdraw-stepper *ngIf="depositshowes =='Withdraw'" [step]=stepperValue></app-withdraw-stepper>
  </div>

  <!-- deposit section -->
  <div [ngClass]="{'dep-w-info-bc':true, 'display-none':depositshowes !='Deposit'}" style="margin-top: 3rem;"
    data-scroll-lock-scrollable="">
    <div class="all">
      <div class="confirm-payment-method">
        <!-- first page -->
        <div [ngClass]="{'display-none':depositeamount}">
          <form [formGroup]="depositaddmonys" class="deposit-forms">
            <div class="amountBox">
              <div class="withdraw_text">
                <p>{{'Please enter the amount to deposit'|translate}}</p>
              </div>
              <div class="diposit_form">
                <div class="w-100 deposit_form_input ">
                  <div class="w-100 deposit_form_input">
                    <div class="inputBox">
                      <input class="deposit_form_input" inputmode="numeric" formControlName="depositamount"
                        (keyup)="amountBlur($event)" (blur)="amountBlur($event)" id="depositamount" name="depositamount"
                        min="0" maxlength="9" autocomplete="off"
                        [ngClass]="{'form-control-input-bc':true,'error-border':depositaddmonys.get('depositamount').touched && depositaddmonys.get('depositamount').invalid}"
                        placeholder="{{'Amount'|translate}}" type="text" (keyup)="inputvalue($event)">
                    </div>
                  </div>
                </div>
                <div *ngIf="amountFirstStepError" class="form-control-message-holder-bc"><span
                    class="form-control-message-holder-bc">
                    {{'Please enter amount'|translate}} </span></div>
                <div
                  *ngIf="clearIndianCurrency(depositaddmonys.get('depositamount').value) < min_max.min && depositaddmonys.get('depositamount').dirty"
                  class="form-control-message-holder-bc"><span class="form-control-message-holder-bc">
                    {{'Amount should be in between'|translate}} {{min_max.min | indianCurrency}} to {{min_max.max |
                    indianCurrency}}</span></div>
                <div *ngIf="clearIndianCurrency(depositaddmonys.get('depositamount').value) > min_max.max"
                  class="form-control-message-holder-bc"><span class="form-control-message-holder-bc">
                    {{'Amount should be in between'|translate}} {{min_max.min | indianCurrency}} to {{min_max.max |
                    indianCurrency}}</span></div>
              </div>
              <div class="stack-button">
                <button class="btn_box" type="button" (click)="depositmoney(300)">
                  <span>
                    +{{300 | indianCurrency}}
                  </span>
                </button>
                <button class="btn_box" type="button" (click)="depositmoney(1000)">
                  <span>
                    +{{1000 | indianCurrency}}
                  </span>
                </button>
                <button class="btn_box" type="button" (click)="depositmoney(5000)">
                  <span>
                    +{{5000 | indianCurrency}}
                  </span>
                </button>
                <button class="btn_box" type="button" (click)="depositmoney(10000)">
                  <span>
                    +{{10000 | indianCurrency}}
                  </span>
                </button>
              </div>
            </div>

            <div class="bonuscard">
              <div class="bonustxt">
                <p>{{'Bonus'|translate}}</p>
              </div>
              <div class="bonusbox" style="margin-bottom: 0.75rem;">
                <div class="bounsinnerbox">
                  <p>{{'Add Promo code'|translate}}</p>
                </div>
                <div class="gift-box">
                  <div class="gift-bonus">
                    <div class="gift-img">
                      <img loading="lazy" src="../../../../../assets/images/gift-box2.png" alt="">
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="16" viewBox="0 0 2 16" fill="none">
                      <path d="M0.75 1L0.749999 15" stroke="white" stroke-opacity="0.08" stroke-linecap="round" />
                    </svg>
                    <div *ngIf="!offerApplied" class="gift-text">
                      <p>{{'Choose Promo & get Bonus'|translate}}</p>
                    </div>
                    <div *ngIf="offerApplied" class="bonus">
                      <div class="applied-bonus">
                        + ₹{{isWelcomeOffer ? welcomeBonus : bonus}}
                      </div>
                      <div>{{'Bonus applied successfully!'|translate}}</div>
                    </div>
                  </div>
                  <div (click)="toggleShowBonusListPopup()" class="get-gift" *ngIf="!offerApplied">
                    <div class="gift-get-svg">
                      <img loading="lazy" src="../../../../../assets/images/gift-get.svg" alt="">
                    </div>
                    <p class="get-btn">{{'GET'|translate}}</p>
                  </div>
                  <div (click)="toggleOffer()" class="get-gift" *ngIf="offerApplied">
                    <div class="gift-get-svg">
                      <img loading="lazy" src="../../../../../assets/images/close-circle.svg" alt="">
                    </div>
                    <p class="get-btn">{{'Remove'|translate}}</p>
                  </div>
                </div>
              </div>
              <!-- zig-zag -->
              <div class="zigzag" *ngIf="offerApplied" @inOutPaneAnimation>
                <div style="display: flex; justify-content: flex-end;">
                  <img loading="lazy" class="star5" src="../../../../../assets/images/star.svg" alt="">
                  <img loading="lazy" class="star6" src="../../../../../assets/images/star.svg" alt="">
                </div>
                <div class="innerohoo-card">
                  <div class="ohoo-svg">
                    <img loading="lazy" src="../../../../../assets/images/gift-image2.png" alt="">
                  </div>
                  <div class="ohoo-text">
                    <p>{{'Wohoo!'|translate}}</p>
                    <p *ngIf="isWelcomeOffer && bonus" style="font-size: 0.75rem;">{{'You will earn'|translate}}
                      <span style="color: #D71082;">₹{{welcomeBonus}}</span> {{'as bonus and'|translate}}
                      <span style="color: #D71082;">₹{{bonus}}</span> {{'as free'|translate}}{{' money in main wallet.'|translate}}
                    </p>
                    <p *ngIf="isWelcomeOffer && !bonus" style="font-size: 0.75rem;">{{'You will earn'|translate}}
                      <span style="color: #D71082;">₹{{welcomeBonus}}</span> {{'as bonus'|translate}}.
                    </p>
                    <p *ngIf="!isWelcomeOffer" style="font-size: 0.75rem;">{{'You will earn'|translate}} <span
                        style="color: #D71082;">₹{{bonus}}</span> {{'as free'|translate}}{{'money in main wallet.'|translate}}
                    </p>
                  </div>
                  <div class="ohoo-text txt">
                  </div>
                  <img loading="lazy" class="star7" src="../../../../../assets/images/star.svg" alt="">
                </div>
              </div>
            </div>
            <button class="btnn"
              [ngClass]="{ 'active': clearIndianCurrency(depositentervalue) >= min_max.min && clearIndianCurrency(depositentervalue) <= min_max.max}"
              [disabled]="clearIndianCurrency(depositentervalue) < min_max.min || clearIndianCurrency(depositentervalue) > min_max.max"
              type="submit" title="Deposit" (click)="showPopUpToggle()">
              {{'Proceed To Select Payment Method'|translate}}
            </button>
          </form>
          <app-promo-info *ngIf="this.promoItemInfo" [popupData]="promoItemInfo.info" (close)="closeInfo()">
          </app-promo-info>
        </div>
        <!-- first page -->

        <!-- secondpage -->
        <div *ngIf="!paymentmethods" class="back-to-amount">
          <div class="back-to-payment">

            <div class="back-nav-bc" (click)="backtodepositeamout()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin: right 0.5rem;"
                viewBox="0 0 14 14" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.21407 11.839C9.47031 11.5828 9.47031 11.1672 9.21407 10.911L5.30308 7L9.21407 3.08905C9.47031 2.83277 9.47031 2.41723 9.21407 2.16094C8.95778 1.9047 8.54224 1.9047 8.28595 2.16094L3.91095 6.53594C3.65471 6.79223 3.65471 7.20777 3.91095 7.46406L8.28595 11.839C8.54224 12.0953 8.95778 12.0953 9.21407 11.839Z"
                  fill="url(#paint0_linear_618_5690)" />
                <defs>
                  <linearGradient id="paint0_linear_618_5690" x1="6.56251" y1="12.0312" x2="6.56251" y2="1.96876"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#CD4295" />
                    <stop offset="1" stop-color="#A70D65" />
                  </linearGradient>
                </defs>
              </svg>
              <span class="back-nav-title-bc ellipsis">{{'Back to Amount'|translate}}</span>
            </div>
            <div class="payment-methods">
              <p class="payment-text" *ngIf="paymentGateways.length>0">{{'Payment Gateways'|translate}}</p>
              <div class="row bank-transfer">
                <ng-container *ngFor="let bank of paymentGateways;let even = even; let odd = odd">
                  <div class="col-6"
                    *ngIf="clearIndianCurrency(this.depositentervalue) >= bank.min && clearIndianCurrency(this.depositentervalue) <= bank.max && !bank?.isManual">
                    <div class="card paycard" [ngClass]="{'child2':odd,'child1':even}"
                      (click)="goToBankPaymentMethod(bank.id)">
                      <div class="quick">
                        <img loading="lazy" src="../../../../../assets/images/quick.svg" alt="">
                        <span>{{'Quick'|translate}}</span>
                      </div>
                      <div class="card-body payicon">
                        <img loading="lazy" src={{bank.account.bankLogo}} class="bankicon" alt="">
                        <span class="bank-name"> {{bank.account.bankName}} </span>
                      </div>
                      <div class="card-footer paycardfooter">
                        <ul class="paymethods" *ngIf="paymentGateways.length<=0">
                          <li><img loading="lazy" src="../../../../../assets/images/imps.svg" class="imps-logo" alt="">
                          </li>
                          <li><span class="pay-method-name">{{'NEFT'|translate}}</span></li>
                          <li><span class="pay-method-name">{{'RTGS'|translate}}</span></li>
                        </ul>
                        <ul class="paymethods" *ngIf="paymentGateways.length>0">
                          <li class="payment-gateway">
                            <span class="gpay">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/gpay.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="phonepe">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/phonepe.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="npci">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/npci.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="paytm">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/paytm.png"
                                alt="">
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <p class="payment-text" *ngIf="nonUpiGateway1.length>0">{{'Bank Transfer'|translate}}</p>
              <div class="row bank-transfer">
                <ng-container *ngFor="let bank of nonUpiGateway1;let even = even; let odd = odd">
                  <div class="col-6"
                    *ngIf="clearIndianCurrency(this.depositentervalue) >= bank.min && clearIndianCurrency(this.depositentervalue) <= bank.max && bank?.isManual">
                    <div class="card paycard" [ngClass]="{'child2':odd,'child1':even}"
                      (click)="goToBankPaymentMethod(bank.id)">
                      <div class="quick">
                        <img loading="lazy" src="../../../../../assets/images/quick.svg" alt="">
                        <span>{{'Quick'|translate}}</span>
                      </div>
                      <div class="card-body payicon">
                        <img loading="lazy" src={{bank.account.bankLogo}} class="bankicon" alt="">
                        <span class="bank-name"> {{bank.account.bankName}} </span>
                      </div>
                      <div class="card-footer paycardfooter">
                        <ul class="paymethods">
                          <li><img loading="lazy" src="../../../../../assets/images/imps.svg" class="imps-logo" alt="">
                          </li>
                          <li><span class="pay-method-name">{{'NEFT'|translate}}</span></li>
                          <li><span class="pay-method-name">{{'RTGS'|translate}}</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <p class="payment-text" *ngIf="upiGateway.length>0">{{'UPI'|translate}}</p>
              <div class="row upi">
                <ng-container *ngFor="let upi of upiGateway; let even = even;let odd = odd">
                  <div class="col-6"
                    *ngIf="clearIndianCurrency(this.depositentervalue) >= upi.min && clearIndianCurrency(this.depositentervalue) <= upi.max">
                    <div class="card paycard" [ngClass]="{'child3':even,'child4':odd}" (click)="goToUpiPage(upi.id)">
                      <div class="quick">
                        <img loading="lazy" src="../../../../../assets/images/quick.svg" alt="">
                        <span>{{'Quick'|translate}}</span>
                      </div>
                      <div class="card-body payicon">
                        <img loading="lazy" src="../../../../../assets/images/upi.svg" alt="">
                        <span class="bank-name"> {{upi?.account?.acNo}} </span>
                      </div>
                      <div class="card-footer paycardfooter">
                        <ul class="paymethods">
                          <li class="payment-gateway">
                            <span class="gpay">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/gpay.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="phonepe">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/phonepe.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="npci">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/npci.png"
                                alt="">
                            </span>
                          </li>
                          <li class="payment-gateway">
                            <span class="paytm">
                              <img loading="lazy" class="inner-image" src="../../../../../assets/images/paytm.png"
                                alt="">
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <!-- secondpage -->

        <!-- bank payment method start -->
        <div *ngIf="!bankPaymentMethod" class="back-to-method">
          <div class="back-nav-bc" (click)="backToPaymentMethod()">
            <img loading="lazy" src="../../../../../assets/images/back-arrow.svg" alt="">
            <span class="back back-nav-title-bc ellipsis">{{'Back to Payment Method'|translate}}</span>
          </div>

          <!-- copied code -->
          <div class="paymethod">
            <div class="accountdetail">
              <p class="make" style="margin-bottom: 0.75rem !important;">{{'Use below details to make payment'|translate}}</p>
              <div class="accountdetailss" *ngIf="!showSkeleton">
                <div class="accountnum">
                  <div class="bankdetail">
                    <img loading="lazy" src="../../../../../assets/images/contact_one.svg" alt="">
                  </div>
                  <div class="banknum">
                    {{'Account Number'|translate}}
                    <div class="icon">
                      <p class="accnum account-number">{{accountdatashow?.account?.acNo}}</p>
                      <p class="svg" (click)="copyToClipboard('.account-number')">
                        <img loading="lazy" src="../../../../../assets/images/clipboard_icon.svg" alt="">
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail">
                    <img loading="lazy" src="../../../../../assets/images/contact_two.svg" alt="">
                  </div>
                  <div class="banknum">
                    {{'Account Name'|translate}}
                    <div class="icon">
                      <p class="accnum account-name">{{accountdatashow?.account?.name}}</p>
                      <p class="svg" (click)="copyToClipboard('.account-name')">
                        <img loading="lazy" src="../../../../../assets/images/clipboard_icon.svg" alt="">
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail">
                    <img loading="lazy" src="../../../../../assets/images/code_block.svg" alt="">
                  </div>
                  <div class="banknum">
                    {{'IFSC'|translate}}
                    <div class="icon">
                      <p class="accnum ifsc-code">{{accountdatashow?.account?.IFSC}}</p>
                      <p class="svg" (click)="copyToClipboard('.ifsc-code')">
                        <img loading="lazy" src="../../../../../assets/images/clipboard_icon.svg" alt="">
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail">
                    <img loading="lazy" src="../../../../../assets/images/institution.svg" alt="">
                  </div>
                  <div class="banknum">
                    {{'Bank Name'|translate}}
                    <div class="icon">
                      <p class="accnum bank-name">{{accountdatashow?.account?.bankName}}</p>
                      <p class="svg" (click)="copyToClipboard('.bank-name')">
                        <img loading="lazy" src="../../../../../assets/images/clipboard_icon.svg" alt="">
                      </p>
                    </div>
                  </div>
                </div>
              </div>


              <!--Skeleton -->
              <div class="accountdetailss skeleton-card" *ngIf="showSkeleton">
                <div class="accountnum">
                  <div class="bankdetail skeleton-img">
                  </div>
                  <div class="banknum">
                    <span class="skeleton-txt"></span>
                    <div class="icon">
                      <p class="accnum account-number skeleton-loader"></p>
                      <p class="svg skeleton-img1"></p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail skeleton-img">
                  </div>
                  <div class="banknum">
                    <span class="skeleton-txt"></span>
                    <div class="icon">
                      <p class="accnum account-number skeleton-loader"></p>
                      <p class="svg skeleton-img1"></p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail skeleton-img">
                  </div>
                  <div class="banknum">
                    <span class="skeleton-txt"></span>
                    <div class="icon">
                      <p class="accnum account-number skeleton-loader"></p>
                      <p class="svg skeleton-img1"></p>
                    </div>
                  </div>
                </div>

                <div class="accountnum">
                  <div class="bankdetail skeleton-img">
                  </div>
                  <div class="banknum">
                    <span class="skeleton-txt"></span>
                    <div class="icon">
                      <p class="accnum account-number skeleton-loader"></p>
                      <p class="svg skeleton-img1"></p>
                    </div>
                  </div>
                </div>
              </div>



              <div class="makepayment" (click)="gotoutrnopage()">
                <div class="madepay">
                  <button>{{'I have Made The Payment'|translate}}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- copied code -->
        </div>
        <!-- bank payment method end -->

        <!-- bank transfer start -->
        <div class="bank-transfer1" *ngIf="!bankTransfer">
          <!-- make payment method start -->
          <div class="paymethod back-nav" (click)="backToBankTransfer()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.21407 11.839C9.47031 11.5828 9.47031 11.1672 9.21407 10.911L5.30308 7L9.21407 3.08905C9.47031 2.83277 9.47031 2.41723 9.21407 2.16094C8.95778 1.9047 8.54224 1.9047 8.28595 2.16094L3.91095 6.53594C3.65471 6.79223 3.65471 7.20777 3.91095 7.46406L8.28595 11.839C8.54224 12.0953 8.95778 12.0953 9.21407 11.839Z"
                fill="url(#paint0_linear_618_5694)" />
              <defs>
                <linearGradient id="paint0_linear_618_5694" x1="6.56251" y1="12.0312" x2="6.56251" y2="1.96876"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#CD4295" />
                  <stop offset="1" stop-color="#A70D65" />
                </linearGradient>
              </defs>
            </svg>
            <span class="back">{{'Back to Make Deposit'|translate}}</span>
          </div>
          <div class="makepay">
            <div class="txt1">
              <p *ngIf="isBankPay">{{'Please select your payment method'|translate}}</p>
              <p *ngIf="!isBankPay">{{'UPI'|translate}}</p>
            </div>
            <div class="makebox" *ngIf="isBankPay">
              <div class="impsbox" (click)="showReceiptUpload('IMPS')">
                <div class="impslog">
                  <input class="impsdott10" [checked]="showReceiptArea == 'IMPS' " name="bank" type="radio">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <img loading="lazy" src="../../../../../assets/images/imps-svg.svg" alt="">
                  </div>
                </div>
                <div class="impstxt">
                  <p>{{'IMPS'|translate}}</p>
                </div>
              </div>
              <div class="impsbox" (click)="showReceiptUpload('NEFT')">
                <div class="impslog1"> <input class="impsdott11" [checked]="showReceiptArea == 'NEFT' " name="bank"
                    type="radio">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <img loading="lazy" src="../../../../../assets/images/neft-svg.svg" alt="">
                  </div>
                </div>
                <div class="impstxt">
                  <p>{{'NEFT'|translate}}</p>
                </div>
              </div>
              <div class="impsbox" (click)="showReceiptUpload('RTGS')">
                <div class="impslog2">
                  <input class="impsdott12" [checked]="showReceiptArea == 'RTGS' " name="bank" type="radio">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <img loading="lazy" src="../../../../../assets/images/rtgs-svg.svg" alt="">
                  </div>
                </div>
                <div class="impstxt">
                  <p>{{'RTGS'|translate}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="utrbox">
            <div class="utrtxt">
              <div class="u-i-p-control-item-holder-bc">
                <p>
                  {{'Enter UTR/Trans ID/Ref ID number to proceed further'|translate}}
                </p>
                <form style="background: #1a2529;" [formGroup]="depositaddmonys" (ngSubmit)="depositResquest()">
                  <div class="u-i-p-control-item-holder-bc mb-3">
                    <div [formGroup]="depositaddmonys"
                      [ngClass]="{'error':depositaddmonys.get('utrnumber').dirty && depositaddmonys.get('utrnumber').invalid}"
                      class="utrinput form-control-bc">
                      <input style="width:100%" id="utrnumber" name="utrnumber" formControlName="utrnumber"
                        minlength="6" maxlength="22" oninput="this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');"
                        [ngClass]="{'error-border':depositaddmonys.get('utrnumber').dirty && depositaddmonys.get('utrnumber').invalid}"
                        placeholder="{{'Enter UTR/Transaction ID/ Ref ID'|translate}}" type="text">
                      <img loading="lazy" *ngIf="depositaddmonys.get('utrnumber').valid"
                        style="position: absolute; right: -1rem; margin-right: 1.5rem;"
                        src="../../../assets/images/right-click-check.svg" alt="">
                    </div>
                  </div>
                  <div
                    *ngIf="depositaddmonys.get('utrnumber').hasError('required') && depositaddmonys.get('utrnumber').touched"
                    class="form-control-message-holder-bc">
                    <span class="form-control-message-bc">
                      {{'Input is required'|translate}}
                    </span>
                  </div>
                  <div *ngIf="depositaddmonys.get('utrnumber').hasError('minlength')"
                    class="form-control-message-holder-bc">
                    <span class="form-control-message-bc">{{"Input can't be less than 6 characters"|translate}}</span>
                  </div>

                </form>
              </div>
            </div>
          </div>
          <div class="upload" *ngIf=" showReceiptArea == 'NEFT' || showReceiptArea == 'RTGS' ">
            <div class="uploadimg">
              <div class="close-button" *ngIf="showImg">
                <svg (click)="closeImage()" xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem"
                  viewBox="0 0 14 15" fill="none" style="border: 1px solid gray; border-radius: 50%; background: gray;">
                  <path _ngcontent-qwy-c36="" fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.91728 10.7587C2.68949 10.9866 2.68952 11.3559 2.91735 11.5837C3.14517 11.8115 3.51452 11.8115 3.7423 11.5836L7.00036 8.32499L10.2587 11.5833C10.4865 11.8111 10.8558 11.8111 11.0836 11.5833C11.3114 11.3555 11.3114 10.9862 11.0836 10.7584L7.82525 7.49998L11.0834 4.24126C11.3111 4.01343 11.3111 3.64409 11.0833 3.41631C10.8555 3.18851 10.4861 3.18855 10.2583 3.41638L7.00024 6.67503L3.74191 3.41666C3.5141 3.18885 3.14475 3.18885 2.91695 3.41666C2.68914 3.64446 2.68914 4.01381 2.91695 4.24162L6.17541 7.50004L2.91728 10.7587Z"
                    fill="#111827">
                  </path>
                </svg>
              </div>
              <div class="uploadsvg">
                <img loading="lazy" id="bank-receipt" [src]="imagePath" *ngIf="showImg"
                  style="border-radius: 0.375rem; width:15rem" src="" alt="">
                <svg *ngIf="showSvg" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32"
                  fill="none">
                  <path
                    d="M29.5 14.6667V22.6667C29.5783 23.3422 29.5028 24.0268 29.2792 24.669C29.0556 25.3113 28.6897 25.8947 28.2088 26.3756C27.7279 26.8564 27.1445 27.2224 26.5023 27.4459C25.86 27.6695 25.1755 27.745 24.5 27.6667H8.49997C7.82442 27.745 7.13991 27.6695 6.49765 27.4459C5.85539 27.2224 5.272 26.8564 4.79111 26.3756C4.31023 25.8947 3.94431 25.3113 3.72072 24.669C3.49714 24.0268 3.42167 23.3422 3.49997 22.6667V9.33337C3.42167 8.65782 3.49714 7.97332 3.72072 7.33105C3.94431 6.68879 4.31023 6.1054 4.79111 5.62452C5.272 5.14364 5.85539 4.77771 6.49765 4.55413C7.13991 4.33054 7.82442 4.25507 8.49997 4.33337H19.1666C19.4318 4.33337 19.6862 4.43873 19.8737 4.62626C20.0613 4.8138 20.1666 5.06815 20.1666 5.33337C20.1666 5.59858 20.0613 5.85294 19.8737 6.04048C19.6862 6.22801 19.4318 6.33337 19.1666 6.33337H8.49997C6.3973 6.33337 5.49997 7.2307 5.49997 9.33337V21.6667L8.88663 18.28C9.13838 18.0302 9.47865 17.8901 9.8333 17.8901C10.1879 17.8901 10.5282 18.0302 10.78 18.28L12.0333 19.5334C12.1579 19.6555 12.3255 19.7239 12.5 19.7239C12.6745 19.7239 12.842 19.6555 12.9666 19.5334L19.5533 12.9467C19.805 12.6969 20.1453 12.5567 20.5 12.5567C20.8546 12.5567 21.1949 12.6969 21.4466 12.9467L27.5 19V14.6667C27.5 14.4015 27.6053 14.1471 27.7929 13.9596C27.9804 13.7721 28.2347 13.6667 28.5 13.6667C28.7652 13.6667 29.0195 13.7721 29.2071 13.9596C29.3946 14.1471 29.5 14.4015 29.5 14.6667ZM11.1573 10.3334C10.7146 10.3346 10.2905 10.5115 9.97815 10.8252C9.66579 11.1388 9.49068 11.5637 9.4913 12.0064C9.49192 12.449 9.66821 12.8734 9.98145 13.1862C10.2947 13.499 10.7193 13.6747 11.162 13.6747C11.6047 13.6747 12.0292 13.499 12.3425 13.1862C12.6557 12.8734 12.832 12.449 12.8326 12.0064C12.8332 11.5637 12.6581 11.1388 12.3458 10.8252C12.0334 10.5115 11.6093 10.3346 11.1666 10.3334H11.1573ZM25.2066 6.7067L25.5 6.4147V9.33337C25.5 9.59858 25.6053 9.85294 25.7929 10.0405C25.9804 10.228 26.2347 10.3334 26.5 10.3334C26.7652 10.3334 27.0195 10.228 27.2071 10.0405C27.3946 9.85294 27.5 9.59858 27.5 9.33337V6.4147L27.7933 6.7067C27.9829 6.88334 28.2336 6.97951 28.4927 6.97494C28.7517 6.97036 28.9989 6.86541 29.1821 6.6822C29.3653 6.49898 29.4703 6.2518 29.4749 5.99273C29.4794 5.73366 29.3833 5.48293 29.2066 5.29337L27.2066 3.29337C27.019 3.10643 26.7649 3.00146 26.5 3.00146C26.2351 3.00146 25.981 3.10643 25.7933 3.29337L23.7933 5.29337C23.6167 5.48293 23.5205 5.73366 23.5251 5.99273C23.5296 6.2518 23.6346 6.49898 23.8178 6.6822C24.001 6.86541 24.2482 6.97036 24.5073 6.97494C24.7663 6.97951 25.0171 6.88334 25.2066 6.7067Z"
                    fill="url(#paint0_linear_517_8279)" />
                  <defs>
                    <linearGradient id="paint0_linear_517_8279" x1="3.46997" y1="5.02199" x2="32.1899" y2="9.13848"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#36E2FA" />
                      <stop offset="1" stop-color="#EBFFBF" />
                    </linearGradient>
                  </defs>
                </svg>
                <div *ngIf="showSvg" class="uploadtxt">
                  <p>{{'Upload Transaction Image'|translate}}</p>
                </div>
                <div *ngIf="showSvg" class="frame">
                  <input (change)="onFileSelected($event)" type="file" accept="image/*" class="file-input"
                    id="fileInput" style="display: none;">
                  <label for="fileInput" class="uploadbtn">{{'Upload'|translate}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="makepayment" (click)="depositResquest()">
            <div class="madepay">
              <button>{{'I have Made The Payment'|translate}}</button>
            </div>
          </div>
        </div>
        <!-- bank transfer end -->

        <!-- deposit last-page -->
        <div *ngIf="!utrnopage">
          <div class="last-utr-section" id="topOfPage">
            <div class="back-nav-bc" (click)="backToPaymentMethod()">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.21407 10.839C6.47031 10.5828 6.47031 10.1672 6.21407 9.91096L2.30308 6L6.21407 2.08905C6.47031 1.83277 6.47031 1.41723 6.21407 1.16094C5.95778 0.904698 5.54224 0.904698 5.28595 1.16094L0.910955 5.53594C0.654711 5.79223 0.654711 6.20777 0.910955 6.46406L5.28595 10.839C5.54224 11.0953 5.95778 11.0953 6.21407 10.839Z"
                  fill="url(#paint0_linear_709_10479)" />
                <defs>
                  <linearGradient id="paint0_linear_709_10479" x1="3.56251" y1="11.0312" x2="3.56251" y2="0.96876"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#CD4295" />
                    <stop offset="1" stop-color="#A70D65" />
                  </linearGradient>
                </defs>
              </svg>
              <span class="back-nav-title-bc ellipsis">{{'Back to Payment Method'|translate}}</span>
            </div>

            <div class="payment-options">

              <!-- OPTION 1 START -->
              <div class="option-one">
                <div class="row">
                  <div class="col-12">
                    <div class="card option">
                      <div class="card-body">
                        <div class="head">
                          <p class="option-head">{{'Option 1'|translate}}</p>
                          <p class="option-text">{{'Scan this QR code from any UPI enabled payment app and pay using UPI.'|translate}}
                          </p>
                        </div>
                        <div class="qr-code">
                          <div class="border-wrapper">
                            <div class="qr">
                              <div [ngClass]="{'spinner1Box':!generatedQrCode}">
                                <span [ngClass]="{'spinner1':!generatedQrCode}"></span>
                              </div>

                              <img loading="lazy" class="qr-image" *ngIf="generatedQrCode" [src]="generatedQrCode"
                                alt="" (load)="generatedQrCode">
                            </div>
                          </div>
                          <div class="save">
                            <button (click)="saveQrCode()">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                fill="none">
                                <path
                                  d="M12.0555 12.134H1.94878C1.64011 12.134 1.38916 12.387 1.38916 12.6936V13.4405C1.38916 13.7491 1.64209 14 1.94878 14H12.0515C12.3601 14 12.6111 13.7471 12.6111 13.4405V12.6936C12.6171 12.383 12.3642 12.134 12.0555 12.134Z"
                                  fill="#D5D9DE" />
                                <path
                                  d="M6.61059 11.1323C6.72013 11.2418 6.86352 11.2976 7.0049 11.2976C7.14829 11.2976 7.29167 11.2418 7.39921 11.1323L11.2268 7.30469C11.4439 7.08764 11.4439 6.73316 11.2268 6.51209L10.6971 5.98236C10.48 5.76528 10.1255 5.76528 9.90448 5.98236L7.93691 7.95193V0.559615C7.93691 0.250925 7.68398 0 7.37732 0H6.6305C6.32184 0 6.07089 0.24892 6.07089 0.559615V7.95391L4.10134 5.98434C3.88426 5.76728 3.5278 5.76728 3.30873 5.98434L2.779 6.51407C2.56195 6.73113 2.56195 7.08761 2.779 7.30667L6.61059 11.1323Z"
                                  fill="#D5D9DE" />
                              </svg>
                              <p>{{'Save'|translate}}</p>
                            </button>
                            <button (click)="shareQrCode()">
                              <img loading="lazy" src="../../../../../assets/images/share_icon.svg" alt="">
                              <p>{{'Share'|translate}}</p>
                            </button>
                            <div class="timer">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                fill="none">
                                <g clip-path="url(#clip0_938_5174)">
                                  <path
                                    d="M9.94723 4.02612L10.5169 3.45648C10.6999 3.27341 10.6999 2.97662 10.5169 2.79357C10.3338 2.61052 10.037 2.6105 9.85397 2.79357L9.28146 3.36608C8.47952 2.70207 7.5063 2.30164 6.46875 2.20873V1.4375H6.9375C7.19639 1.4375 7.40625 1.22764 7.40625 0.96875C7.40625 0.709859 7.19639 0.5 6.9375 0.5H5.0625C4.80361 0.5 4.59375 0.709859 4.59375 0.96875C4.59375 1.22764 4.80361 1.4375 5.0625 1.4375H5.53125V2.20873C4.48584 2.30234 3.50585 2.70828 2.70045 3.38129L2.1127 2.79355C1.92963 2.61048 1.63284 2.61048 1.4498 2.79355C1.26675 2.97662 1.26673 3.27341 1.4498 3.45645L2.03754 4.0442C1.26476 4.96897 0.84375 6.12395 0.84375 7.34375C0.84375 10.1935 3.14991 12.5 6 12.5C8.84972 12.5 11.1562 10.1938 11.1562 7.34375C11.1562 6.11595 10.7297 4.9539 9.94723 4.02612ZM6 11.5625C3.67378 11.5625 1.78125 9.66997 1.78125 7.34375C1.78125 5.01753 3.67378 3.125 6 3.125C8.32622 3.125 10.2188 5.01753 10.2188 7.34375C10.2188 9.66997 8.32622 11.5625 6 11.5625Z"
                                    fill="white" />
                                  <path
                                    d="M7.875 6.875H6.46875V4.53125C6.46875 4.27236 6.25889 4.0625 6 4.0625C4.19072 4.0625 2.71875 5.53447 2.71875 7.34375C2.71875 9.15303 4.19072 10.625 6 10.625C6.59583 10.625 7.17982 10.4629 7.68884 10.1563C7.9106 10.0227 7.98209 9.73466 7.84849 9.51289C7.71492 9.29112 7.4269 9.21964 7.20509 9.35323C6.84209 9.57193 6.42537 9.6875 6 9.6875C4.70766 9.6875 3.65625 8.63609 3.65625 7.34375C3.65625 6.21188 4.46276 5.26489 5.53125 5.04713V7.34375C5.53125 7.60264 5.74111 7.8125 6 7.8125H7.875C8.13389 7.8125 8.34375 7.60264 8.34375 7.34375C8.34375 7.08486 8.13389 6.875 7.875 6.875Z"
                                    fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_938_5174">
                                    <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <p>{{minutes}} : {{seconds}}</p>
                              <p> {{'Min'|translate}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="valid-warning">
                          <div class="valid-warn">
                            <img loading="lazy" src="../../../../../assets/images/error-icon.svg" alt="" srcset="">
                            <p>
                              {{'This QR is valid only for 45 minutes and on this transaction. Please use it for 1 time only. We are not responsible for payments if you use it more than once.'|translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- OPTION 1 END -->

              <!-- OPTION 2 START -->
              <div class="option-two">
                <div class="row">
                  <div class="col-12">
                    <div class="card option">
                      <div class="card-body">
                        <div class="head">
                          <p class="option-head">{{'Option 2'|translate}}</p>
                          <p class="option-text">{{'Pay to the following UPI from any app.'|translate}}
                          </p>
                        </div>
                        <div class="npci-method">
                          <ul class="paymethods">
                            <li class="method-list" (click)="selecUpiMethod('gpay')">
                              <div class="payment-gateway" [ngClass]="{'active':selectedUpiMethod=='gpay'}">
                                <span class="gpay">
                                  <img loading="lazy" class="inner-image" src="../../../../../assets/images/gpay.png"
                                    alt="">
                                </span>
                              </div>
                              <p [ngClass]="{'active':selectedUpiMethod=='gpay'}">
                                {{'Google Pay'|translate}}</p>
                            </li>
                            <li class="method-list" (click)="selecUpiMethod('phonepe')">
                              <div class="payment-gateway" [ngClass]="{'active':selectedUpiMethod=='phonepe'}">
                                <span class="phonepe">
                                  <img loading="lazy" class="inner-image"
                                    src="../../../../../assets/images/phonepe2.png" alt="">
                                </span>
                              </div>
                              <p [ngClass]="{'active':selectedUpiMethod=='phonepe'}">
                                {{'PhonePe'|translate}}</p>
                            </li>
                            <li class="method-list" (click)="selecUpiMethod('paytm')">
                              <div class="payment-gateway" [ngClass]="{'active':selectedUpiMethod=='paytm'}">
                                <span class="paytm">
                                  <img loading="lazy" class="inner-image"
                                    src="../../../../../assets/images/Paytm2-1.svg" alt="">
                                </span>

                              </div>
                              <p [ngClass]="{'active':selectedUpiMethod=='paytm'}">{{'Paytm'|translate}}
                              </p>

                            </li>
                            <li class="method-list" (click)="selecUpiMethod('npci')">
                              <div class="payment-gateway" [ngClass]="{'active':selectedUpiMethod=='npci'}">
                                <span class="npci">
                                  <img loading="lazy" class="inner-image" src="../../../../../assets/images/npci.png"
                                    alt="">
                                </span>

                              </div>
                              <p [ngClass]="{'active':selectedUpiMethod=='npci'}">{{'Bhim'|translate}}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- OPTION 2 END -->

              <!-- OPTION 3 START -->
              <div class="accountdetail">
                <div class="accountdetailss">
                  <div class="acctxt">
                    <div class="option3">{{'Option 3'|translate}}</div>
                    <div class="paragraph">
                      <p>{{'Pay to the following UPI from any app.'|translate}}</p>
                    </div>
                  </div>
                  <div class="accountnum">
                    <div class="bankdetail">
                      <img loading="lazy" src="../../../../../assets/images/bhim-svg.svg" alt="">
                    </div>
                    <div class="banknum">
                      <div>
                        {{'UPI ID'|translate}}
                      </div>
                      <div class="icon">
                        <p class="accnum upi-id">{{accountdatashow?.account?.acNo}}</p>
                        <p class="svg">
                          <img loading="lazy" (click)="copyToClipboard('.icon .upi-id')"
                            src="../../../../../assets/images/copy-icon.svg" alt="">
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accountnum">
                    <div class="bankdetail">
                      <img loading="lazy" src="../../../../../assets/images/banksvg.svg" alt="">
                    </div>
                    <div class="banknum">
                      <div>
                        {{'Bank Name'|translate}}
                      </div>
                      <div class="icon">
                        <p class="accnum">{{accountdatashow?.account?.bankName}}</p>
                        <!-- <img src="../../../../../assets/images/copy-icon.svg" alt=""> -->
                      </div>
                    </div>
                  </div>
                  <div class="accountnum">
                    <div class="bankdetail">
                      <img loading="lazy" src="../../../../../assets/images/personsvg.svg" alt="">
                    </div>
                    <div class="banknum">
                      <div>
                        {{'Account Name'|translate}}
                      </div>
                      <div class="icon">
                        <p class="accnum">{{accountdatashow?.account?.name}}</p>
                        <p class="svg">
                          <!-- <img src="../../../../../assets/images/copy-icon.svg" alt=""> -->
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="makepayment" (click)="goToBankTransfer()">
                  <div class="madepay">
                    <button>{{'I Paid'|translate}}</button>
                  </div>
                </div>
              </div>
              <!-- OPTION 3 END -->


            </div>

          </div>
        </div>
        <!-- deposit last-page -->
      </div>
    </div>
  </div>
  <!-- deposit section -->

  <!-- withdraw section -->
  <div style="margin-top: 3.00rem;" class='dep-w-info-bc' *ngIf="depositshowes =='Withdraw'"
    data-scroll-lock-scrollable="">

    <!--withdraw first page start-->
    <div class="withdraw-section" *ngIf="withdrawFirstPage">
      <div class="bonus-amount">
        <img loading="lazy" class="bonus-star1" src="../../../../../assets/images/star.svg" alt="">
        <img loading="lazy" class="bonus-star2" src="../../../../../assets/images/star.svg" alt="">
        <img loading="lazy" class="bonus-star3" src="../../../../../assets/images/star.svg" alt="">
        <img loading="lazy" class="wallet-logo" src="../../../../../assets/images/new-wallet.svg" alt="">
        <div class="">
          <img loading="lazy" class="wallet-3D-frame" src="../../../../../assets/images/wallet-frame.svg" alt="">
          <img loading="lazy" class="wallet-3d" src="../../../../../assets/images/3D-wallet.svg" alt="">
        </div>
        <div class="wallet-card">
          <span class="wallet-amount">₹ {{balanceWithoutBonus}}</span>
          <div class="wallet-txt">
            <p>{{'Main Wallet'|translate}}</p>
            <div class="with-any">
              <p>{{'Can withdraw anytime'|translate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="active-bonus-card">
        <div class="active-bonus-inner-card">
          <div class="money-text">
            <p>{{'Free Money'|translate}}</p>
            <p class="money-bal">₹ {{bonusMoney}}</p>
          </div>
          <div class="money-text">
            <p>{{'Active Bonus'|translate}}</p>
            <p class="money-bal">₹ {{activeBonusOfUser}}</p>
          </div>

          <div class="progressbar">
            <div class="progressbg" [style.width.%]="activeBonusPercent">
              <div class="progressdot"></div>
            </div>
          </div>
          <!-- progress bar -->
          <div class="wallet-msg">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M13.4801 3.08634C12.5267 1.99967 10.4801 1.33301 8.00008 1.33301C5.52008 1.33301 3.47341 1.99967 2.52008 3.08634C0.933411 4.92634 0.933411 11.0863 2.52008 12.913C3.47341 13.9997 5.52008 14.6663 8.00008 14.6663C10.4801 14.6663 12.5267 13.9997 13.4801 12.913C15.0667 11.073 15.0667 4.92634 13.4801 3.08634ZM8.00008 4.49967C8.1649 4.49967 8.32601 4.54855 8.46305 4.64012C8.6001 4.73168 8.70691 4.86183 8.76998 5.0141C8.83305 5.16638 8.84955 5.33393 8.8174 5.49558C8.78525 5.65723 8.70588 5.80572 8.58933 5.92226C8.47279 6.03881 8.32431 6.11817 8.16265 6.15033C8.001 6.18248 7.83345 6.16598 7.68118 6.10291C7.5289 6.03983 7.39876 5.93302 7.30719 5.79598C7.21562 5.65894 7.16675 5.49783 7.16675 5.33301C7.16675 5.11199 7.25454 4.90003 7.41082 4.74375C7.5671 4.58747 7.77907 4.49967 8.00008 4.49967ZM8.66675 11.6663H7.33341C7.1566 11.6663 6.98703 11.5961 6.86201 11.4711C6.73698 11.3461 6.66675 11.1765 6.66675 10.9997C6.66675 10.8229 6.73698 10.6533 6.86201 10.5283C6.98703 10.4032 7.1566 10.333 7.33341 10.333V8.33301C7.1566 8.33301 6.98703 8.26277 6.86201 8.13775C6.73698 8.01272 6.66675 7.84315 6.66675 7.66634C6.66675 7.48953 6.73698 7.31996 6.86201 7.19494C6.98703 7.06991 7.1566 6.99967 7.33341 6.99967H8.00008C8.17689 6.99967 8.34646 7.06991 8.47148 7.19494C8.59651 7.31996 8.66675 7.48953 8.66675 7.66634V10.333C8.84356 10.333 9.01313 10.4032 9.13815 10.5283C9.26317 10.6533 9.33341 10.8229 9.33341 10.9997C9.33341 11.1765 9.26317 11.3461 9.13815 11.4711C9.01313 11.5961 8.84356 11.6663 8.66675 11.6663Z"
                fill="#F75555" />
            </svg>
            <p>{{'The free money and any active bonus funds will be removed if you make a withdrawal.'|translate}}</p>
          </div>
        </div>
      </div>
      <div class="amount-input">
        <p class="amount-text">{{'Please enter the amount to withdraw'|translate}}</p>
        <form action="" style="width: 100%;" [formGroup]="withdrawMoney">
          <div class="diposit_form">
            <div class="w-100 deposit_form_input ">
              <div class="w-100 deposit_form_input">
                <div
                  [ngClass]="{'input-error':clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) > availableBalance ||( clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) < getWithdrawLimit() && withdrawMoney.get('withdrawAmount').touched)}"
                  class="inputBox">
                  <input class="deposit_form_input" inputmode="numeric" formControlName="withdrawAmount" maxlength="13"
                    (input)="withdrawAmountBlur($event)" (blur)="withdrawAmountBlur($event)" id="depositamount"
                    name="depositamount" min="0"
                    [ngClass]="{'error-border':withdrawMoney.get('withdrawAmount').touched && withdrawMoney.get('withdrawAmount').invalid || clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) < getWithdrawLimit()}"
                    placeholder="{{'₹ Amount'|translate}}" type="text" (keyup)="withdrawInputvalue($event)">
                  <p class="deposit-input-min-text">{{'minimum ₹'|translate}}{{getWithdrawLimit()}}</p>
                </div>
              </div>
            </div>
            <div *ngIf="amountFirstStepError" class="form-control-message-holder-bc"><span
                class="form-control-message-holder-bc">
                {{'Please enter amount'|translate}} </span></div>
            <div
              *ngIf="clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) >= getWithdrawLimit() && withdrawMoney.get('withdrawAmount').value && clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) < availableBalance"
              class="form-control-message-holder-bc"><span class="form-control-message-holder-bc error-msg">
                {{'Min amount ₹'|translate}}{{getWithdrawLimit()}}</span></div>
            <div
              *ngIf="clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) < getWithdrawLimit() && withdrawMoney.get('withdrawAmount').value"
              class="form-control-message-holder-bc"><span class="form-control-message-holder-bc">{{"Amount can't be less than ₹"|translate}}{{getWithdrawLimit()}}</span></div>
            <div *ngIf="clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) > availableBalance"
              class="form-control-message-holder-bc"><span class="form-control-message-holder-bc">
                {{'Insufficient balance in your main wallet.'|translate}}</span></div>
          </div>
        </form>
      </div>
      <button (click)="goToWithdrawPage('second')"
        [disabled]="clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) < getWithdrawLimit() || clearIndianCurrency(withdrawMoney.get('withdrawAmount').value) > availableBalance || !withdrawMoney.get('withdrawAmount').value"
        class="btnn1">{{'Continue to Select Account'|translate}}</button>
    </div>
    <!--withdraw first page end-->

    <!--withdraw second page start-->
    <div class="bank-account-section" *ngIf="withdrawSecondPage">
      <div class="back-nav-bc" (click)="backToFirstPage()">
        <img loading="lazy" src="../../../../../assets/images/back-arrow.svg" alt="">
        <span class="back-nav-title-bc ellipsis">{{'Back to Amount'|translate}}</span>
      </div>
      <div style="width:100%;gap:1rem;display:grid;" *ngIf="bankDetailsAvailable">
        <div *ngFor="let bank of withdrawaccountlist; let i = index" (click)="selectBankAccount(bank.accountId)"
          [ngClass]="{'bank-card3': i % 3 === 0, 'bank-card2': i % 3 === 1, 'bank-card1': i % 3 === 2, 'active': bank?.accountId === selectedWithdrawBank?.accountId}">
          <div [ngClass]="{'bank-logo3': i % 3 === 0, 'bank-logo2': i % 3 === 1, 'bank-logo1': i % 3 === 2}">
            <div class="logo">
              <img loading="lazy" [src]="bankLogoLinks[bank?.IFSCCode.toUpperCase().substring(0, 4)]" alt="">
              <p>{{bank.accountName}}</p>
            </div>
          </div>
          <div class="bank-inner-box">
            <div class="bank-detail">
              <div style="width: max-content; display:flex; flex-direction: row;">
                <span>{{'Bank'|translate}} :-</span>
                <span class="bank-detail-txt">{{bank.bankName}}</span>
              </div>
              <div (click)="goToRemovePopup(bank.accountId)">
                <img loading="lazy" class="delete-logo" src="../../../../../assets/images/delete-icon.svg" alt="">
              </div>
            </div>
            <div class="bank-detail">
              <div style="width: max-content; display:flex; flex-direction: row;">
                <span>{{'IFSC'|translate}} :-</span>
                <span class="bank-detail-txt">{{bank.IFSCCode | uppercase}}</span>
              </div>
            </div>
            <div class="bank-detail">
              <div style="width: max-content; display:flex; flex-direction: row;">
                <span>{{'Account No'|translate}} :-</span>
                <span class="bank-detail-txt">{{bank.accountNo}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="bank-account-box" *ngIf="!bankDetailsAvailable">
        <div class="bank-account-inner">
          <div class="bank-card">
            <img loading="lazy" src="../../../../../assets/images/bank3d.svg" alt="">
            <p>{{"You don't have any bank account added"|translate}}</p>
            <button (click)="showAddBankAccount()"><span>{{'Add Bank Account'|translate}}</span></button>
          </div>
        </div>
      </div>
      <!-- buttons -->
      <div class="withdraw-page-buttons" *ngIf="bankDetailsAvailable">
        <button (click)="showAddBankAccount()" *ngIf="bankDetailsAvailable" class="plus-btn">
          <img loading="lazy" src="../../../../../assets/images/plus-logo.svg" alt="">
          <span>{{'Add Bank Account'|translate}}</span>
        </button>
        <button (click)="goToWithdrawPage('third')" [disabled]="!selectedWithdrawBank?.accountId"
          class="process-btn"><span>{{'Proceed'|translate}}</span></button>
      </div>
      <!-- buttons -->

    </div>
    <!--withdraw second page end-->

    <!--withdraw third page start-->
    <div class="withdraw-account" *ngIf="withdrawThirdPage">
      <div class="back-nav-bc" (click)="backToSecondPage()">
        <img loading="lazy" src="../../../../../assets/images/back-arrow.svg" alt="">
        <span class="back-nav-title-bc ellipsis">{{'Back to Select Account'|translate}}</span>
      </div>
      <div class="withdraw-amount">
        <span>{{'Withdrawal Amount'|translate}}</span>
        <div (click)="goToWithdrawPage('first')" *ngIf="isDisabled" class="edit-logo">
          <img loading="lazy" src="../../../../../assets/images/edit.svg" alt="">
        </div>
        <!-- <div (click)="editWithdrawInput()" *ngIf="!isDisabled" class="edit-logo">
          <img src="../../../../../assets/images/right-click.svg" alt="">
        </div> -->
      </div>
      <input [disabled]="isDisabled" type="text" name="" [value]="withdrawMoney.get('withdrawAmount').value">
      <div class="bank-account">
        <span>{{'Bank Account'|translate}}</span>
        <div class="edit-logo" (click)="goToWithdrawPage('second')">
          <img loading="lazy" src="../../../../../assets/images/edit.svg" alt="">
        </div>
      </div>
      <div class="bank-card1">
        <div class="bank-logo1">
          <div class="logo">
            <img loading="lazy" [src]="bankLogoLinks[selectedWithdrawBank?.IFSCCode.toUpperCase().substring(0, 4)]"
              alt="">
            <p>{{selectedWithdrawBank?.accountName}}</p>
          </div>
        </div>
        <div class="bank-inner-box">
          <div class="bank-detail">
            <div style="width: max-content; display:flex; flex-direction: row;">
              <span>{{'Bank'|translate}} :-</span>
              <span style="margin-left: 0.2rem;">{{selectedWithdrawBank?.bankName}}</span>
            </div>
          </div>
          <div class="bank-detail">
            <div style="width: max-content; display:flex; flex-direction: row;">
              <span>{{'IFSC'|translate}} :-</span>
              <span style="margin-left: 0.2rem;">{{selectedWithdrawBank?.IFSCCode | uppercase}}</span>
            </div>
          </div>
          <div class="bank-detail">
            <div style="width: max-content; display:flex; flex-direction: row;">
              <span>{{'Account No'|translate}} :-</span>
              <span class="bank-detail-txt">{{selectedWithdrawBank?.accountNo}}</span>
            </div>
          </div>
        </div>
      </div>
      <button (click)="withdrawAmountFromBank()" class="proceed-btn"><span>{{'Proceed'|translate}}</span></button>
    </div>
    <!--withdraw third page end-->
  </div>
  <!-- withdraw section -->

  <!-- account statement section -->
  <div style="margin-top: 1.5rem;"
    [ngClass]="{'u-i-e-p-p-content-bc':true ,'u-i-common-content':true, 'display-none':depositshowes !='TransactionHistory'}"
    data-scroll-lock-scrollable="">
    <div>
      <div [ngClass]="{'display-none':acountshow}">

        <div class="componentFilterWrapper-bc">
          <div [ngClass]="{'componentFilterLabel-bc':true, 'active':showhideaccountfilter}" (click)="accountfiler()"><i
              class="componentFilterLabel-filter-i-bc bc-i-filter"></i>
            <div class="componentFilterLabel-filter-bc">
              <p class="ellipsis">{{'Filter'|translate}}</p>
            </div><i class="componentFilterChevron-bc bc-i-small-arrow-down"></i>
          </div>
          <div class="componentFilterBody-bc">
            <div class="componentFilterElsWrapper-bc">
              <div class="filter-form-w-bc">




                <mat-form-field appearance="fill" class="filed-data">
                  <mat-label class="dtapickerlabel">{{'Select date range'|translate}}</mat-label>
                  <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                    <input class="data1" matStartDate formControlName="start" placeholder="Start date">
                    <input class="data1" matEndDate formControlName="end" placeholder="End date">
                  </mat-date-range-input>

                  <mat-datepicker-toggle matSuffix [for]="picker" class="dropdownIcon-bc"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>

                  <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">{{'Invalid start date'|translate}}</mat-error>
                  <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">{{'Invalid end date'|translate}}</mat-error>
                </mat-form-field>





                <div class="u-i-p-c-footer-bc"><button (click)="filteraccountstatement();accountfiler()"
                    class="btn a-color " title="Show"><span>{{'Show'|translate}}</span></button></div>
              </div>
            </div>
          </div>
        </div>



        <div class="historyList-bc" *ngFor="let acountdetails of filldata">


          <div class="historyListEl"
            (click)="acountdetails.description?.eventName && acountdetails.description?.eventName !== 'Evolution' && accountdetails(acountdetails.description.market)">
            <div class="historyListEl-list">

              <div class="historyListEl-id-content">
                <div class="historyListEl-id"></div><b
                  class="historyListEl-id-number open-bet-name">{{!acountdetails.description?.eventName?acountdetails.actionDisplayName:acountdetails.description.eventName}}</b>
              </div><time Name class="historyListEl-date heighliter"><b>{{'Bal.'|translate}}{{acountdetails.balance |
                  indianCurrency}}
                </b></time>
            </div>
            <div class="historyListEl-list">
              <div class="historyListEl-id-content">
                <div class="historyListEl-id"></div><span class="historyListEl-id">{{'Date'|translate}}</span>
              </div><time class="historyListEl-date heighliter1"><b>{{acountdetails.date |
                  date:'medium'}}</b></time>
            </div>



            <div class="historyListEl">

              <div class="historyListEl-list-item ">
                <div class="historyListEl-title ellipsis">{{'Description'|translate}}</div>
                <div class="historyListEl-info ellipsis heighliter1">{{acountdetails.actionDisplayName}}
                </div>
              </div>
              <div class="historyListEl-list-item ">
                <div class="historyListEl-title ellipsis">{{'P&L'|translate}}</div>
                <div class="historyListEl-info ellipsis heighliter1 mota" data-cur="₹"
                  [ngClass]="acountdetails.pnl >= 0 ? 'win':'loss'">
                  {{acountdetails.pnl | indianCurrency}}</div>
              </div>
              <div class="historyListEl-list-item ">
                <div class="historyListEl-title ellipsis">{{'Credit limit'|translate}}</div>
                <div class="historyListEl-info ellipsis heighliter1" data-cur="₹">
                  {{acountdetails.creditLimit == null ?'-':acountdetails.creditLimit }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div>
        <div [ngClass]="{'u-i-p-c-body-bc':true, 'display-none':accountdetailsshow }">

          <div _ngcontent-smf-c84="" class="back-nav-bc"><i (click)="backacountdetaisl()"
              class="back-nav-icon-bc bc-i-round-arrow-left" tabindex="0" ng-reflect-router-link="/account"></i><span
              _ngcontent-smf-c84="" class="back-nav-title-bc ellipsis text-white">{{'Account Statement Details'|translate}}</span>
          </div>
          <div class="">
            <div class="historyList-bc">
              <div class="historyListEl">
                <div *ngFor="let acountdetails of accountStatementss">
                  <div class="historyListEl-list" style="background: rgba(var(--b-sc-rgb), 0.1);">
                    <div class="historyListEl-id-content">
                      <div class="historyListEl-id"></div><b
                        class="historyListEl-id-number">{{acountdetails.eventName}}</b>
                    </div>
                  </div>

                  <div class="historyListEl-list">
                    <div class="historyListEl-id-content">
                      <div class="historyListEl-id">{{'Selection:'|translate}}</div><b class="historyListEl-id-number "
                        [ngClass]="{'historyListEl-id-number':true, 'lay-event':acountdetails.side == 1, 'back-event':acountdetails.side == 0}">
                        {{acountdetails.marketType=='INNING_RUNS' ?
                        acountdetails.line +' Runs':acountdetails.selectionName}}</b>
                    </div>
                    <time class="historyListEl-date heighliter1"
                      [ngClass]="{'win': acountdetails.outcome === 'WON','loss': acountdetails.outcome === 'LOST'}">Status:
                      {{acountdetails.outcome}}</time>

                  </div>

                  <div class="historyListEl-list">
                    <div class="historyListEl-id-content">
                      <div class="historyListEl-id">{{'Bet ID:'|translate}}</div><b
                        class="historyListEl-id-number">{{acountdetails?.apolloBetId}}</b>
                    </div><time class="historyListEl-date heighliter1"
                      [ngClass]="acountdetails.profitLoss>=0 ? 'win':'loss'">{{'Profit/Loss:'|translate}}
                      {{acountdetails?.profitLoss}}</time>

                  </div>



                  <div class="historyListEl-list-item ">
                    <div class="historyListEl-title ellipsis">
                      {{'Placed'|translate}}:</div>
                    <div class="historyListEl-info ellipsis heighliter1">
                      {{acountdetails?.betPlacedDate|date:'medium'}}</div>
                  </div>

                  <div class="historyListEl-list-item ">
                    <div class="historyListEl-title ellipsis">{{'TYPE'|translate}}</div>
                    <div class="historyListEl-info ellipsis heighliter1">{{acountdetails?.side == 1
                      ?
                      'No':'Yes'}}
                    </div>
                  </div>
                  <div class="historyListEl-list-item ">
                    <div class="historyListEl-title ellipsis">{{'ODDS'|translate}}</div>
                    <div class="historyListEl-info ellipsis heighliter1">
                      {{acountdetails?.averagePrice}}</div>
                  </div>
                  <div class="historyListEl-list-item ">
                    <div class="historyListEl-title ellipsis">{{'STAKE'|translate}}</div>
                    <div class="historyListEl-info ellipsis heighliter1">{{acountdetails?.size}}
                    </div>
                  </div>


                  <span class="historyListEl-list-item-separator"></span>
                </div>
                <div class="historyListEl-list-item ">
                  <div class="historyListEl-title ellipsis">{{'Back subtotal'|translate}}</div>
                  <div class="historyListEl-info ellipsis heighliter1" data-cur="₹"> {{Backsubtotal}}
                  </div>
                </div>
                <div class="historyListEl-list-item ">
                  <div class="historyListEl-title ellipsis">{{'Lay subtotal'|translate}}</div>
                  <div class="historyListEl-info ellipsis heighliter1" data-cur="₹">{{Laysubtotal}}
                  </div>
                </div>
                <div class="historyListEl-list-item ">
                  <div class="historyListEl-title ellipsis">{{'Market subtotal'|translate}}</div>
                  <div class="historyListEl-info ellipsis heighliter1" data-cur="₹">
                    {{Marketsubtotal}}
                  </div>
                </div>
                <div class="historyListEl-list-item ">
                  <div class="historyListEl-title ellipsis">{{'Commission'|translate}}</div>
                  <div class="historyListEl-info ellipsis heighliter1" data-cur="₹">
                    0.00
                  </div>
                </div>
                <div class="historyListEl-list-item ">
                  <div class="historyListEl-title ellipsis">{{'Net market Total'|translate}}</div>
                  <div class="historyListEl-info ellipsis heighliter1" data-cur="₹">
                    {{NetmarketTotal}}</div>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>




    </div>

    <div
      [ngClass]="{'u-i-e-p-p-content-bc':true ,'u-i-common-content':true, 'display-none':depositshowes !='depositWithdrawReport'}"
      data-scroll-lock-scrollable="">
      <div class="componentFilterWrapper-bc" (click)="accountfiler()">
        <div [ngClass]="{'componentFilterLabel-bc':true,'active':showhideaccountfilter }"><i
            class="componentFilterLabel-filter-i-bc bc-i-filter"></i>
          <div class="componentFilterLabel-filter-bc">
            <p class="ellipsis text">{{'Filters'|translate}}</p>
          </div><i class="componentFilterChevron-bc bc-i-small-arrow-down"></i>
        </div>
        <div class="componentFilterBody-bc">
          <div class="componentFilterElsWrapper-bc">
            <form class="filter-form-w-bc">
              <div class="u-i-p-control-item-holder-bc">
                <div class="form-control-bc select has-icon valid filled"><label
                    class="form-control-label-bc inputs"><select class="form-control-select-bc active" name="product"
                      step="0">
                      <option value="">{{'Main'|translate}}</option>
                      <option value="Casino">{{'Casino'|translate}}</option>
                    </select><i class="form-control-icon-bc bc-i-small-arrow-down"></i><i
                      class="form-control-input-stroke-bc"></i><span
                      class="form-control-title-bc ellipsis">{{'Category'|translate}}</span></label></div>
              </div>
              <div class="u-i-p-control-item-holder-bc halfPartFilterSection">
                <div class="react-datepicker-wrapper">
                  <div class="react-datepicker__input-container">
                    <div class="form-control-bc default filled valid filled"><label
                        class="form-control-label-bc inputs">
                        <input class="form-control-input-bc " type="text" placeholder="From" readonly=""
                          value="09.03.2023"><i class="form-control-input-stroke-bc"></i><span
                          class="form-control-title-bc ellipsis">{{'Range'|translate}}</span><i
                          class="dropdownIcon-bc bc-i-datepicker"></i></label></div>
                  </div>
                </div>
              </div>
              <div class="u-i-p-control-item-holder-bc halfPartFilterSection">
                <div class="react-datepicker-wrapper">
                  <div class="react-datepicker__input-container">
                    <div class="form-control-bc default filled valid filled"><label
                        class="form-control-label-bc inputs"><input class="form-control-input-bc " type="text"
                          placeholder="To" readonly="" value="19.03.2023"><i
                          class="form-control-input-stroke-bc"></i><span
                          class="form-control-title-bc ellipsis"></span><i
                          class="dropdownIcon-bc bc-i-datepicker"></i></label></div>
                  </div>
                </div>
              </div>
              <div class="u-i-p-c-footer-bc"><button class="btn a-color " type="submit"
                  title="Show"><span>{{'Show'|translate}}</span></button></div>
            </form>
          </div>
        </div>
      </div>

      <div class="historyList-bc">
        <div class="historyListEl">
          <div class="historyListEl-list">
            <div class="historyListEl-id-content">
              <div class="historyListEl-id">{{'ID'|translate}}:</div><b class="historyListEl-id-number">115061329209</b><i
                title="Copy id" class="bc-booking-copy bc-i-copy"></i>
            </div><time class="historyListEl-date">12.03.2023, 01:29 AM</time>
          </div>
          <div class="historyListEl-list">
            <div class="historyListEl-id-content">
              <div class="historyListEl-id">{{'ID'|translate}}:</div><b class="historyListEl-id-number">172139264158</b><i
                title="Copy id" class="bc-booking-copy bc-i-copy"></i>
            </div>
          </div><span class="historyListEl-list-item-separator"></span>
          <div class="historyListEl-list-item ">
            <div class="historyListEl-title ellipsis">{{'Type'|translate}}</div>
            <div class="historyListEl-info ellipsis">{{'Deposit (PaykassmaPhonePe)'|translate}}</div>
          </div><span class="historyListEl-list-item-separator"></span>
          <div class="historyListEl-list-item ">
            <div class="historyListEl-title ellipsis">{{'Amount'|translate}}</div>
            <div class="historyListEl-info ellipsis" data-cur="₹">+300.00</div>
          </div>
          <div class="historyListEl-list-item ">
            <div class="historyListEl-title ellipsis">{{'Final Balance'|translate}}</div>
            <div class="historyListEl-info ellipsis" data-status="1" data-cur="₹">300.00</div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{'dep-w-info-bc':true, 'display-none':depositshowes !='WithdrawStatus'}">
      <p class="text-white">{{'Withdraw status'|translate}}</p>
    </div>
  </div>
  <!-- account statement section -->


  <!-- // edit withdrawal popup -->
  <div class="modal fade" id="exampleModals" tabindex="-1" aria-labelledby="exampleModalLabels" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="u-i-p-p-u-i-edit-button-bc"><span class="account-verified-edit-title ellipsis">{{'Edit Withdrawal Details'|translate}}</span> <i class="hdr-user-close bc-i-close-remove close" data-bs-dismiss="modal"
              aria-label="Close"></i> </h2>

        </div>
        <div class="modal-body">
          <p class="text-white">{{'Reference number:'|translate}}{{withdrawaldetailsshowonpage?.requestId}}</p>
          <div>
            <form [formGroup]="depositedit" (ngSubmit)="depositEdit(withdrawaldetailsshowonpage?.requestId)">
              <div class="u-i-p-control-item-holder-bc">
                <p class="label-amount">{{'UTR'|translate}}</p>
                <div class="form-control-bc default valid filled">
                  <label class="form-control-label-bc inputs depositeinput">
                    <input type="text" class="form-control-input-bc" minlength="6" maxlength="12"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');" formControlName="utredit" name="utredit"
                      step="0" value="">
                    <i class="form-control-input-stroke-bc"></i>
                  </label>
                </div>
              </div>

              <div class="u-i-p-control-item-holder-bc">
                <p class="label-amount">{{'Amount'|translate}}</p>
                <div class="form-control-bc default valid filled">
                  <label class="form-control-label-bc inputs depositeinput">
                    <input type="text" class="form-control-input-bc" formControlName="amountedit"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'')" name="amountedit" step="0" value="">
                    <i class="form-control-input-stroke-bc "></i>
                  </label>
                </div>
              </div>
              <div class="u-i-p-c-footer-bc">
                <button class="btn a-color  depositeLogout" #closebutton type="submit" title="Logout"
                  data-bs-dismiss="modal" style="margin-top: 14px;">
                  <span>{{'Submit Changes'|translate}}</span>
                </button>
              </div>
            </form>
          </div>

        </div>

      </div>
    </div>
  </div>
  <!--  edit withdrawal popup   cancel withdrawal popup -->

  <div class="modal fade" id="exampleModal1w" tabindex="-1" aria-labelledby="exampleModalLabel1w" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="u-i-p-p-u-i-edit-button-bc"><span
              class="account-verified-edit-title ellipsis canceldeposite">{{'Cancel withdrawal'|translate}} </span> <i
              class="hdr-user-close bc-i-close-remove close" data-bs-dismiss="modal" aria-label="Close"></i>
          </h2>

        </div>
        <div class="modal-body">

          <div>
            <form [formGroup]="canceldeposit"
              (ngSubmit)="transactionreportcancel(withdrawaldetailsshowonpage?.requestId)">
              <label class="form-control-label-bc inputs cancel">
                <textarea type="text" class="form-control-input-bc textarea-cancel" formControlName="remarks"
                  name="remarks" placeholder="Please Enter Reason for cancelling (Optional)" step="0"
                  value=""></textarea>
                <i class="form-control-input-stroke-bc"></i></label>

              <div class="u-i-p-c-footer-bc"><button class="btn a-color  depositeLogout" #closebutton type="submit"
                  data-bs-dismiss="modal" title="Logout"><span>{{'Submit Changes'|translate}}</span></button></div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!--  edit withdrawal popup   cancel withdrawal popup -->
  <div class="Modal-Background max-width-550" *ngIf="!showPopUp" [ngClass]="{'display-none':showPopUp}">
    <div class="depositpop">
      <div class="depositbreak">
        <p>{{'Deposit Breakdown'|translate}}</p>
        <div class="close-svg" (click)="showPopUpToggle()">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.91703 10.7588C2.68924 10.9867 2.68928 11.356 2.9171 11.5838C3.14493 11.8116 3.51427 11.8116 3.74206 11.5837L7.00012 8.32511L10.2584 11.5834C10.4862 11.8112 10.8556 11.8112 11.0834 11.5834C11.3112 11.3556 11.3112 10.9863 11.0834 10.7585L7.82501 7.5001L11.0832 4.24138C11.3109 4.01356 11.3109 3.64421 11.083 3.41643C10.8552 3.18864 10.4859 3.18867 10.2581 3.4165L7 6.67516L3.74166 3.41678C3.51386 3.18897 3.14451 3.18897 2.91671 3.41678C2.6889 3.64459 2.6889 4.01393 2.91671 4.24174L6.17517 7.50016L2.91703 10.7588Z"
              fill="#111827" />
          </svg>
        </div>
      </div>
      <div class="deposit-inner">
        <div class="balancebox">
          <div class="damount">
            <div class="balancetxt">
              <p>{{'Deposit Amount'|translate}}</p>
            </div>
            <div class="amt">
              <p>₹ {{depositentervalue}}</p>
              <p *ngIf="isWelcomeOffer" class="depamt">+{{ welcomeBonus }} {{'Bonus'|translate}}</p>
            </div>
          </div>
          <div class="moneybox">
            <p class="money">{{percentageBonus}}% {{'Instant Money'|translate}}</p>
            <p class="doll">₹{{ bonus }}</p>
          </div>
          <div class="line"></div>
          <div class="totalamt">
            <p class="money">{{'Total Amount Credited'|translate}}</p>
            <p class="doll1">
              ₹ {{ isWelcomeOffer ?
              depositentervalue + bonus + welcomeBonus :
              depositentervalue + bonus
              }}
            </p>
          </div>
        </div>
        <div class="giftbox">
          <img loading="lazy" class="star1" src="../../../../../assets/images/star.svg" alt="">
          <img loading="lazy" class="star2" src="../../../../../assets/images/star.svg" alt="">
          <div class="gift-input">
            <p class="money">{{'Amount credited In main wallet'|translate}}</p>
            <p class="doll">₹ {{depositentervalue + bonus}}</p>
          </div>
          <img loading="lazy" class="star3" src="../../../../../assets/images/star.svg" alt="">
        </div>
        <div class="giftbox1" *ngIf="isWelcomeOffer">
          <img loading="lazy" class="star1" src="../../../../../assets/images/star.svg" alt="">
          <img loading="lazy" class="star2" src="../../../../../assets/images/star.svg" alt="">
          <div class="gift-input">
            <p class="money">{{'Amount credited In bonus card'|translate}}</p>
            <p class="doll">₹{{welcomeBonus}}</p>
          </div>
          <img loading="lazy" class="star4" src="../../../../../assets/images/star.svg" alt="">
        </div>
        <div (click)="gotopaymentmethod()" class="makepayment">
          <div class="madepay">
            <button type="button" (click)="trackInitiateCheckout()">{{'Confirm'|translate}} </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Deposit promo code popup-->
  <app-balance-popup class="Modal-Background max-width-550" [title]="'Choose Promo & get Bonus'"
    (closeClick)="showBonusListPopup = false" *ngIf="showBonusListPopup">
    <div class="inputbonusbox">
      <img loading="lazy" src="../../../../../assets/images/promo-gift.svg" alt="" style="height: 36px;">
      <input [value]="promoId" class="promoinput" type="text" disabled placeholder="Enter Promo & get Bonus">
    </div>
    <div class="innerbonusbox">
      <h2>{{'Select Bonus'|translate}} </h2>
      <!-- <app-how-to-bonus2 [bonus]="showHowTo2" (close)="showHowTo2 = null" *ngIf="showHowTo2"></app-how-to-bonus2> -->


      <ng-container *ngFor="let item of promocode let even=even;let odd=odd">
        <div class="promocard" [ngClass]="{'promocard':even,'promocard1':odd}">
          <img loading="lazy" [ngClass]="{'promo-star':even,'promo-star3':odd}" class="promo-star"
            src="../../../../../assets/images/star.svg" alt="">
          <img loading="lazy" [ngClass]="{'promo-star1':even,'promo-star4':odd}" class="promo-star1"
            src="../../../../../assets/images/star.svg" alt="">
          <img loading="lazy" [ngClass]="{'promo-star2':even,'promo-star5':odd}" class="promo-star2"
            src="../../../../../assets/images/star.svg" alt="">
          <div class="promo-inner">
            <div class="promobox">
              <img loading="lazy" src="../../../../../assets/images/img/gift.svg" *ngIf="even" alt="">
              <img loading="lazy" src="../../../../../assets/images/img/gift1.svg" *ngIf="odd" alt="">
              <p>{{item['short-info']}} <svg (click)="showHowToBonus(item)" xmlns="http://www.w3.org/2000/svg"
                  width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <g clip-path="url(#clip0_2875_12070)">
                    <path
                      d="M7.4375 6.41699C7.4375 6.17538 7.24162 5.97949 7 5.97949C6.75838 5.97949 6.5625 6.17538 6.5625 6.41699V9.91699C6.5625 10.1586 6.75838 10.3545 7 10.3545C7.24162 10.3545 7.4375 10.1586 7.4375 9.91699V6.41699Z"
                      fill="#D1D5DB" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.99984 0.729492C3.53655 0.729492 0.729004 3.53704 0.729004 7.00033C0.729004 10.4636 3.53655 13.2712 6.99984 13.2712C10.4631 13.2712 13.2707 10.4636 13.2707 7.00033C13.2707 3.53704 10.4631 0.729492 6.99984 0.729492ZM1.604 7.00033C1.604 4.02029 4.0198 1.60449 6.99984 1.60449C9.97985 1.60449 12.3957 4.02029 12.3957 7.00033C12.3957 9.98034 9.97985 12.3962 6.99984 12.3962C4.0198 12.3962 1.604 9.98034 1.604 7.00033Z"
                      fill="#D1D5DB" />
                    <path
                      d="M7.58317 4.66732C7.58317 4.98948 7.32201 5.25065 6.99984 5.25065C6.67766 5.25065 6.4165 4.98948 6.4165 4.66732C6.4165 4.34515 6.67766 4.08398 6.99984 4.08398C7.32201 4.08398 7.58317 4.34515 7.58317 4.66732Z"
                      fill="#D1D5DB" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2875_12070">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg></p>
            </div>
          </div>
          <button (click)="selectOffer(item)" [ngClass]="{'promo-btn':even,'promo-btn1':odd}" class="promo-btn">
            <span>{{'Apply'|translate}}</span>
          </button>
          <div class="slide"></div>
        </div>
      </ng-container>
    </div>
  </app-balance-popup>



  <!-- Deposit congo popup-->
  <app-balance-popup class="Modal-Background max-width-550" *ngIf="showCongoPopup"
    (closeClick)="showCongoPopup = false;gotoMainPageHome()">
    <div class="congo-box">
      <div class="congo">
        <!-- <img loading="eager" class="phatake" src="../../../../../assets/images/firework.gif" alt="congratulations"
          id="animatedGif" (load)="depositGifImage=true"> -->
      </div>
      <div class="congo-msg">
        <h1>{{'Congratulations!'|translate}}</h1>
        <p style="color: gray;">{{'Your deposit request for'|translate}} <span style="color: green;">
            ₹ {{formatToIndianCurrency(depositentervalue)}} </span> {{'has been submitted successfully'|translate}}</p>
      </div>
      <div class="zigzag" *ngIf="offerApplied">
        <div style="display: flex; justify-content: flex-end;">
          <img loading="lazy" class="star5" src="../../../../../assets/images/star.svg" alt="">
          <img loading="lazy" class="star6" src="../../../../../assets/images/star.svg" alt="">
        </div>
        <div class="innerohoo-card last-popup-bonus">
          <div class="ohoo-svg">
            <img loading="lazy" src="../../../../../assets/images/gift-image2.png" alt="">
          </div>
          <div class="ohoo-text">
            <p *ngIf="isWelcomeOffer && bonus" style="font-size: 0.75rem;">{{'You will earn'|translate}}
              <span style="color: #D71082;">₹{{welcomeBonus}}</span> {{'as bonus and'|translate}}
              <span style="color: #D71082;">₹{{bonus}}</span> {{'as free money in your main wallet.'|translate}}
            </p>
            <p *ngIf="isWelcomeOffer && !bonus" style="font-size: 0.75rem;">{{'You will earn'|translate}}
              <span style="color: #D71082;">₹{{welcomeBonus}}</span> {{'as bonus'|translate}}.
            </p>
            <p *ngIf="!isWelcomeOffer" style="font-size: 0.75rem;">{{'You will earn'|translate}} <span
                style="color: #D71082;">₹{{bonus}}</span> {{'as free money in your main wallet'|translate}}
            </p>
          </div>
          <img loading="lazy" class="star7" src="../../../../../assets/images/star.svg" alt="">
        </div>
      </div>

    </div>

    <div (click)="goToHome()" class="makepayment">
      <div class="madepay">
        <button>{{'Start Playing'|translate}}</button>
      </div>
    </div>
  </app-balance-popup>


  <!--Deposit UPI Congo popup -->
  <app-balance-popup class="Modal-Background max-width-550" *ngIf="showUpiCongoPopup" (closeClick)="showUpiCongoPopup = false; ">
    <div class="congo-box">
      <div class="congo2">
        <!-- <img loading="eager" class="phatake" src="../../../../../assets/images/firework.gif" alt=""> -->
      </div>
      <div class="congo-msg">
        <h1 style="margin-top: 1rem;">{{'Congratulations!'|translate}}</h1>
        <p style="color: gray; margin-top: 0.38rem;">{{"You've earned"|translate}} <span style="color: green;">
            ₹ {{formatToIndianCurrency(depositentervalue)}} </span> {{'as Free money in your main wallet'|translate}}.</p>
      </div>
    </div>

    <div class="makepayment" style="margin-top: 2.62rem;">
      <div class="madepay">
        <button (click)="goToHome()">{{'Start Playing'|translate}}</button>
      </div>
    </div>
  </app-balance-popup>

  <!--Deposit Upi Details Popup-->
  <app-upi-popup class="Modal-Background max-width-550" style="z-index: 9999999;" (closeClick)="userUpiDetailPopup = false"
    *ngIf="userUpiDetailPopup">
    <div class="user-popup">
      <div class="approval-box">
        <img loading="lazy" src="../../../../../assets/images/approval-svg.svg" alt="">
        <span>{{'Transaction Successful'|translate}}</span>
        <p>25 Auguest 2023 at 10:00 PM</p>
      </div>
      <div class="txn-box">
        <div class="txn-card">
          <div class="txn-input">
            <div class="txn-inner">
              <img loading="lazy" class="logo" src="../../../../../assets/images/txn-logo.svg" alt="">
              <div class="txn-id">
                <p>{{'Transaction ID'|translate}}</p>
                <span>T2629526292269522984</span>
              </div>
            </div>
            <div class="txn-copy">
              <span>{{'Copy'|translate}}</span>
              <img loading="lazy" src="../../../../../assets/images/copy-text-logo.svg" alt="">
            </div>
          </div>
        </div>
        <div class="txn-paid-card">
          <span class="txn-paid">{{'Paid to'|translate}}</span>
          <div class="inner-card">
            <div class="main-card">
              <img loading="lazy" src="../../../../../assets/images/zig-arrow.svg" alt="">
              <div class="text-card">
                <span>Cameron Williamson</span>
                <p>9265******</p>
              </div>
            </div>
            <span class="amount">₹2100</span>
          </div>
          <p>Send Again</p>
        </div>
        <div class="txn-paid-card">
          <span class="txn-paid">Debited From</span>
          <div class="inner-card">
            <div class="main-card">
              <img loading="lazy" src="../../../../../assets/images/zig-arrow.svg" alt="">
              <div class="text-card">
                <span>XXXXXX1111</span>
                <p>UTR : 123456789123</p>
              </div>
            </div>
            <span class="amount">₹2100</span>
          </div>
          <p>Split Expense</p>
        </div>
        <div class="phone-support">
          <img loading="lazy" src="../../../../../assets/images/question-logo.svg" alt="">
          <span>Contact Phonepe Support</span>
        </div>
      </div>
    </div>
  </app-upi-popup>

  <!--Withdraw add account popup-->
  <app-balance-popup class="Modal-Background max-width-550" [title]="'Add Bank Account'"
    (closeClick)="withdrawPopup = false; this.addBankAccountForm.reset();" *ngIf="withdrawPopup">

    <div class="bank-popup">
      <form [formGroup]="addBankAccountForm">
        <div class="input-box">
          <p>{{'Account Holder Name'|translate}}*</p>
          <input formControlName="accountName" (input)="onTextInput($event)" type="text"
            placeholder="Enter Account Holder Name" name="">
        </div>
        <div
          *ngIf="addBankAccountForm.get('accountName').value?.length === 0 && addBankAccountForm.get('accountName').touched"
          class="error-msg-account-No">
          <span>{{'This field is required'|translate}}</span>
        </div>
        <div class="input-box">
          <p>{{'Account Number*'|translate}}</p>
          <input inputmode="numeric" (paste)="onPaste($event)" formControlName="accountNumber" (input)="onInput($event)"
            (keydown)="onKeyDownForAcc($event)" maxlength="18" minlength="0" [type]="showAccountNumberinput"
            placeholder="{{'Enter Account Number'|translate}}" name="">
          <span class="showAccountNo" (click)="showAccountNumberInput()">
            <img loading="lazy" *ngIf="showAccountNumberinput === 'password'"
              src="../../../../../assets/images/view_password_eye.svg" />
            <img loading="lazy" *ngIf="showAccountNumberinput === 'number'"
              src="../../../../../assets/images/eye-open.svg" />
          </span>
        </div>
        <div
          *ngIf="addBankAccountForm.get('accountNumber').value?.length < 5  && addBankAccountForm.get('accountNumber').value?.length > 0 && addBankAccountForm.get('accountNumber').dirty"
          class="error-msg-account-No">
          <span>{{"Account No can't be less than 5 digits."|translate}}</span>
        </div>
        <div
          *ngIf="addBankAccountForm.get('accountNumber').value?.length === 0 && addBankAccountForm.get('accountNumber').touched"
          class="error-msg-account-No">
          <span>{{'This field is required'|translate}}</span>
        </div>
        <div class="input-box">
          <p>{{'Confirm Account Number*'|translate}}</p>
          <input inputmode="numeric" (paste)="onPaste($event)" formControlName="confirmAccountNumber"
            (input)="onInput($event)" (keydown)="onKeyDownForAcc($event)" maxlength="18" minlength="5" type="text"
            [type]="showConfirmAccountNumberinput" placeholder="{{'Enter Account Number'|translate}}" name="">
          <span class="showAccountNo" (click)="showConfirmAccountNumberInput()">
            <img loading="lazy" *ngIf="showConfirmAccountNumberinput === 'password'"
              src="../../../../../assets/images/view_password_eye.svg" />
            <img loading="lazy" *ngIf="showConfirmAccountNumberinput === 'number'"
              src="../../../../../assets/images/eye-open.svg" />
          </span>
        </div>

        <div
          *ngIf="addBankAccountForm.get('confirmAccountNumber').value?.length ===0 && addBankAccountForm.get('confirmAccountNumber').touched"
          class="error-msg-account-No">
          <span>{{'This field is required'|translate}}</span>
        </div>
        <div
          *ngIf="(addBankAccountForm.get('accountNumber').value !== addBankAccountForm.get('confirmAccountNumber').value && addBankAccountForm.get('confirmAccountNumber').value?.length > 0 )"
          class="error-msg-account-No">
          <span>{{'Account No does not match.'|translate}}</span>
        </div>
        <div class="input-box">
          <p>{{'IFSC Code*'|translate}}</p>
          <input (keyup)="getBankDetailsByIfsc($event)" ype="text" [minLength]="11"
            (input)="getIfscValidationsErrormessage()" [maxLength]="11" formControlName="ifscCode"
            placeholder="IFSC0000001" name="">
        </div>
        <div
          *ngIf="addBankAccountForm.get('ifscCode').value?.length === 0 && addBankAccountForm.get('ifscCode').touched"
          class="error-msg-account-No">
          <span>{{'This field is required'|translate}}</span>
        </div>
        <div
          *ngIf="invalidIfscErrorMessage===true && addBankAccountForm.get('ifscCode').dirty && addBankAccountForm.get('ifscCode').value?.length > 0 "
          class="error-msg-account-No">
          <span>{{"First 4 characters must be uppercase alphabets."|translate}}</span>
        </div>
        <div
          *ngIf="addBankAccountForm.get('ifscCode').value?.length > 5  &&  addBankAccountForm.get('ifscCode').dirty && !enteredBankdetails"
          class="error-msg-account-No">
          <span>{{'The last 6 characters must be digits or alphabets only.'|translate}}</span>
        </div>
        <div
          *ngIf="fifthCharacterIfsc===true && addBankAccountForm.get('ifscCode').dirty && addBankAccountForm.get('ifscCode').value?.length >= 5 "
          class="error-msg-account-No">
          <span>{{'Fifth character must be 0.'|translate}}</span>
        </div>
      </form>
      <div *ngIf="enteredBankdetails" class="bank-img">
        <div class="bank-img-inner">
          <div class="bank-logo bank-ifsc">
            <img loading="lazy" [src]="enteredBankdetails.link" alt="">
            <p *ngIf="!spinner">{{enteredBankdetails?.BANK}}</p>
            <p class="spinner" *ngIf="spinner"></p>
          </div>
          <h6 *ngIf="!spinner">{{enteredBankdetails?.BRANCH}}</h6>
          <h6 class="spinner" *ngIf="spinner"></h6>
        </div>
      </div>
      <div class="btn-box">
        <button (click)="cancelAddAccount()" class="cancel-btn"><span>{{'Cancel'|translate}}</span></button>
        <button (click)="showAccountDetailPage()" [disabled]="addBankAccountForm.invalid" class="add-btn">
          <span>{{'Add Bank Account'|translate}}</span></button>
        <!-- <button *ngIf="" class="add-btn"><span>Update</span></button> -->
      </div>
    </div>
  </app-balance-popup>

  <!-- Withdraw congo popup-->
  <app-balance-popup class="Modal-Background max-width-550" *ngIf="withdrawCongoPopup"
    (closeClick)="withdrawCongoPopup = false;gotoMainPageHome()">
    <div class="congo-box">
      <div class="congo1">
        <!-- <img loading="eager" class="phatake" src="../../../../../assets/images/firework.gif"
          alt="withdrawcongratulation" id="animatedGifForWithDraw"> -->
      </div>
      <div class="congo-msg">
        <h1>{{'Congratulations!'|translate}}</h1>
        <span style="color: gray;">{{'Your withdraw request has been received. The amount will be debited within 15 minutes from your wallet.'|translate}}</span>
      </div>
    </div>

    <div class="makepayment">
      <div class="madepay">
        <button (click)="goToHome()">{{'Go Back'|translate}}</button>
      </div>
    </div>

  </app-balance-popup>

  <!-- withdraw Remove popup-->
  <app-center-popup class="Modal-Background max-width-550" [title]="'Remove Account'" (closeClick)="removePopup = false"
    *ngIf="removePopup" @inOutPaneAnimation>
    <div class="hr-line"></div>
    <div class="remove-text">
      <span>{{'Are you sure you want to remove this account'|translate}}</span>
    </div>
    <div class="remove-btn">
      <button (click)="removePopup = false" class="cancel-btnn"><span>{{'Cancel'|translate}}</span></button>
      <button (click)="deleteWithdrawBank()" class="confirm-btnn"><span>{{'Yes, Remove'|translate}}</span></button>
    </div>
  </app-center-popup>

  <!-- withdraw limit popup-->
  <app-center-popup class="Modal-Background max-width-550" [title]="'Limit Reached'" (closeClick)="bankLimitPopup=false"
    *ngIf="bankLimitPopup">
    <div class="hr-line"></div>
    <p class="limit-text">{{"You can only add up to five bank accounts. If you'd like to add another account, kindly remove one from your current list."|translate}}</p>
  </app-center-popup>
</div>


<!-- Bonus card 2 -->

<div class="Modal-Background max-width-550 parent-backdrop-profile" *ngIf="showHowTo2"></div>

<div class="Modal-Background info-page-profile max-width-550" *ngIf="showHowTo2" (closeClick)="showCongoPopup = false;">
  <div class="background-design-info-profile">
    <span class="rectangle"></span>
    <span class="rectangle1"></span>
    <span class="rectangle2"></span>
    <span class="rectangle3"></span>
    <span class="rectangle4"></span>
    <span class="rectangle5"></span>
    <span class="icon1">
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="33" viewBox="0 0 44 33" fill="none">
        <g opacity="0.3">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M43.5824 24.6022C45.8247 20.7481 38.8128 12.555 27.9213 6.31166C17.0347 0.0633075 6.38703 -1.87139 4.14473 1.98272C2.90399 4.1194 1.66344 6.26112 0.417636 8.3978C-1.82484 12.2519 5.18721 20.445 16.0788 26.6883C26.9704 32.9367 37.613 34.8714 39.8553 31.0173C41.101 28.8808 42.3415 26.7389 43.5824 24.6022Z"
            fill="#FE9923" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M27.921 6.31166C17.0344 0.0633075 6.38673 -1.87139 4.14443 1.98272C1.9072 5.84187 8.91907 14.03 19.8056 20.2733C30.6972 26.5216 41.3449 28.4563 43.5821 24.6022C45.8246 20.7481 38.8125 12.555 27.921 6.31166Z"
            fill="#FECD3D" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M26.0245 9.57503C17.365 4.60456 9.37169 2.24072 8.17676 4.29647C6.98184 6.34735 13.0378 12.0452 21.7023 17.0104C30.3668 21.9809 38.3601 24.3447 39.555 22.289C40.7449 20.2383 34.689 14.5455 26.0245 9.57503Z"
            fill="#FEA832" />
          <path
            d="M4.95792 12.8118L2.97488 16.2263C2.50198 15.6504 2.07995 15.0848 1.71387 14.5341L3.27488 11.8418L4.95792 12.8118ZM6.65617 20.0047C7.13414 20.429 7.63746 20.8585 8.15616 21.2827L10.0476 18.0297L8.36455 17.065L6.65617 20.0047ZM12.2698 24.3236C12.7986 24.6772 13.3427 25.0307 13.902 25.3793L15.707 22.2728L14.0189 21.3131L12.2698 24.3236ZM18.3054 27.9099C18.8902 28.2129 19.47 28.5059 20.0497 28.7838L21.7988 25.7732L20.1107 24.8034L18.3054 27.9099ZM24.753 30.7992C25.3836 31.0366 26.0039 31.2539 26.6191 31.4509L28.3276 28.5111L26.6395 27.5514L24.753 30.7992ZM31.7496 32.7338C32.4921 32.85 33.1937 32.9307 33.8598 32.9712L35.4208 30.284L33.7378 29.3142L31.7496 32.7338Z"
            fill="#C85929" />
        </g>
      </svg>
    </span>
    <span class="icon2">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="43" viewBox="0 0 49 43" fill="none">
        <g opacity="0.6">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.71427 34.5255C4.60643 31.8042 8.2735 22.5375 15.9022 13.8219C23.528 5.11211 32.2312 0.250004 35.3389 2.97133C37.0588 4.47826 38.7786 5.98524 40.5045 7.49508C43.6109 10.2119 39.9438 19.4786 32.3151 28.1943C24.6849 36.9055 15.9861 41.7661 12.8799 39.0492C11.1586 37.5378 9.43423 36.0324 7.71427 34.5255Z"
            fill="#FE9923" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M15.9022 13.8219C23.528 5.11211 32.2312 0.250004 35.3389 2.97133C38.4452 5.68818 34.7782 14.9549 27.1495 23.6705C19.5207 32.3862 10.8206 37.2423 7.71427 34.5255C4.60643 31.8042 8.2735 22.5375 15.9022 13.8219Z"
            fill="#FECD3D" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M18.5299 16.1228C24.6003 9.19394 30.8583 4.74886 32.5127 6.19393C34.1686 7.64358 30.5896 14.4367 24.5206 21.3699C18.4517 28.3032 12.1893 32.7499 10.5378 31.2988C8.88214 29.8492 12.4611 23.0561 18.5299 16.1228Z"
            fill="#FEA832" />
          <path
            d="M37.8652 12.7172L40.614 15.1253C40.8542 14.4795 41.0576 13.8564 41.2107 13.26L39.0427 11.3665L37.8652 12.7172ZM38.5332 19.5337C38.2433 20.0479 37.9326 20.574 37.6073 21.1004L34.9849 18.8025L36.1655 17.4608L38.5332 19.5337ZM34.928 24.9853C34.574 25.457 34.2054 25.9288 33.8263 26.3991L31.3247 24.2086L32.5053 22.8669L34.928 24.9853ZM30.7374 29.9238C30.3196 30.3677 29.9004 30.7924 29.4839 31.2112L27.0551 29.0898L28.2371 27.7377L30.7374 29.9238ZM25.9855 34.3758C25.5024 34.7727 25.0264 35.1475 24.5533 35.5014L22.1812 33.4301L23.3647 32.0824L25.9855 34.3758ZM20.4578 38.1469C19.8513 38.4721 19.2591 38.7529 18.6905 38.9859L16.5268 37.0909L17.7088 35.7389L20.4578 38.1469Z"
            fill="#C85929" />
        </g>
      </svg>
    </span>
    <span class="icon3">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path opacity="0.18"
          d="M7.37409 0V3.94356H11.3174V7.36718H7.37409V11.3174H3.95047V7.36718H0V3.94356H3.95047V0H7.37409Z"
          fill="#FEA832" />
      </svg>
    </span>
    <span class="icon4">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path opacity="0.18"
          d="M7.37409 0V3.94356H11.3174V7.36718H7.37409V11.3174H3.95047V7.36718H0V3.94356H3.95047V0H7.37409Z"
          fill="#FEA832" />
      </svg>
    </span>
    <span class="icon5">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
        <g opacity="0.3">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M19.8102 11.1828C20.8294 9.43095 17.6422 5.7068 12.6915 2.86893C7.74306 0.0287762 2.9032 -0.850633 1.88397 0.901237C1.32 1.87245 0.756108 2.84596 0.189834 3.81718C-0.829474 5.56905 2.35782 9.2932 7.30854 12.1311C12.2593 14.9712 17.0968 15.8506 18.1161 14.0988C18.6823 13.1276 19.2461 12.154 19.8102 11.1828Z"
            fill="#FE9923" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.6914 2.86893C7.74297 0.0287761 2.90311 -0.850633 1.88388 0.901237C0.866952 2.6554 4.05417 6.37725 9.00258 9.21512C13.9533 12.0553 18.7932 12.9347 19.8101 11.1828C20.8294 9.43095 17.6421 5.7068 12.6914 2.86893Z"
            fill="#FECD3D" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11.8294 4.35176C7.89329 2.09245 4.25995 1.01798 3.7168 1.95241C3.17365 2.88463 5.92635 5.47454 9.86475 7.73148C13.8032 9.99079 17.4365 11.0653 17.9796 10.1308C18.5205 9.19869 15.7678 6.61106 11.8294 4.35176Z"
            fill="#FEA832" />
          <path
            d="M2.25338 5.8237L1.352 7.37577C1.13704 7.114 0.94521 6.85689 0.778809 6.60656L1.48836 5.38281L2.25338 5.8237ZM3.02531 9.09322C3.24257 9.28608 3.47135 9.4813 3.70712 9.67415L4.56687 8.1955L3.80185 7.75698L3.02531 9.09322ZM5.57696 11.0563C5.81734 11.2171 6.06464 11.3778 6.31885 11.5362L7.13933 10.1242L6.37201 9.68797L5.57696 11.0563ZM8.32043 12.6865C8.58625 12.8242 8.84976 12.9574 9.11327 13.0837L9.90832 11.7153L9.141 11.2745L8.32043 12.6865ZM11.2511 13.9998C11.5378 14.1077 11.8197 14.2065 12.0994 14.296L12.876 12.9598L12.1087 12.5235L11.2511 13.9998ZM14.4314 14.8792C14.7689 14.932 15.0878 14.9687 15.3906 14.9871L16.1001 13.7656L15.3351 13.3248L14.4314 14.8792Z"
            fill="#C85929" />
        </g>
      </svg>
    </span>
    <span class="icon6">
      <svg xmlns="http://www.w3.org/2000/svg" width="58" height="138" viewBox="0 0 58 138" fill="none">
        <g clip-path="url(#clip0_2660_31639)" filter="url(#filter0_i_2660_31639)">
          <mask id="mask0_2660_31639" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="-79" y="0" width="137"
            height="138">
            <path d="M8.91417 0.913367L-78.2544 49.9199L-29.2478 137.088L57.9207 88.0819L8.91417 0.913367Z"
              fill="white" />
          </mask>
          <g mask="url(#mask0_2660_31639)">
            <path
              d="M17.0654 76.6315C71.5392 91.8988 -33.064 150.707 -17.7993 96.2325C-33.064 150.707 -91.8722 46.1043 -37.401 61.3666C-91.8722 46.1043 12.731 -12.704 -2.53635 41.7656C12.731 -12.704 71.5392 91.8988 17.0654 76.6315Z"
              fill="url(#paint0_linear_2660_31639)" fill-opacity="0.1" />
          </g>
        </g>
        <defs>
          <filter id="filter0_i_2660_31639" x="-78.2544" y="0.914062" width="140.175" height="140.174"
            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dx="4" dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2660_31639" />
          </filter>
          <linearGradient id="paint0_linear_2660_31639" x1="-34.6701" y1="25.4167" x2="14.3364" y2="112.585"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#DF99F7" />
            <stop offset="1" stop-color="#FFDBB0" />
          </linearGradient>
          <clipPath id="clip0_2660_31639">
            <rect width="100" height="100" fill="white" transform="translate(-78.2544 49.9199) rotate(-29.3449)" />
          </clipPath>
        </defs>
      </svg>
    </span>
    <span class="icon7">
      <svg xmlns="http://www.w3.org/2000/svg" width="43" height="73" viewBox="0 0 43 73" fill="none">
        <path opacity="0.2"
          d="M77.0866 35.7062C93.51 60.9096 62.1308 72.5265 42.2828 72.5265C22.7626 72.5265 0.698364 65.1772 0.698364 42.4921C0.708153 -15.8618 48.8923 -7.54231 77.0866 35.7062Z"
          fill="url(#paint0_linear_2660_31630)" />
        <defs>
          <linearGradient id="paint0_linear_2660_31630" x1="41.1898" y1="0.996094" x2="41.1898" y2="72.5265"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFC461" />
            <stop offset="1" stop-color="#FF9639" />
          </linearGradient>
        </defs>
      </svg>
    </span>
    <span class="icon8">
      <svg xmlns="http://www.w3.org/2000/svg" width="74" height="96" viewBox="0 0 74 96" fill="none">
        <path opacity="0.2"
          d="M83.8899 78.7487C90.1716 78.1491 96.8289 80.6009 103.056 81.9881C108.87 83.29 120.316 83.4151 125.918 80.8571C135.606 76.4397 141.339 60.6827 132.935 51.5987C123.289 41.1714 106.266 40.4912 92.7007 37.085C71.7606 31.823 73.5545 14.7334 55.2476 4.41764C48.2382 0.470745 36.7881 -1.47309 30.1903 4.62957C21.8171 12.3571 27.8164 10.2839 15.1761 26.9359C11.2559 29.3083 -3.04186 39.9246 1.62623 54.61C3.6303 60.9147 11.9671 64.7472 17.6146 68.7155C23.0473 72.5276 28.9222 74.646 33.1047 79.8297C38.6881 86.7605 44.2069 95.9723 54.1077 95.1451C66.8565 94.0688 72.228 79.8722 83.8899 78.7487Z"
          fill="#FF8AA9" />
      </svg>
    </span>
    <span class="free-money-profile-bets">
      <span class="free-money">Free Money</span>
      <span (click)="closeInfoPage()" class="close">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="22" height="22" rx="10" fill="#9CA3AF" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.91728 14.2593C6.68949 14.4872 6.68952 14.8565 6.91735 15.0843C7.14517 15.3121 7.51452 15.3121 7.7423 15.0842L11.0004 11.8256L14.2587 15.0839C14.4865 15.3117 14.8558 15.3117 15.0836 15.0839C15.3114 14.8561 15.3114 14.4868 15.0836 14.259L11.8253 11.0006L15.0834 7.74187C15.3111 7.51404 15.3111 7.1447 15.0833 6.91692C14.8555 6.68912 14.4861 6.68916 14.2583 6.91699L11.0002 10.1756L7.74191 6.91727C7.5141 6.68946 7.14475 6.68946 6.91695 6.91727C6.68914 7.14507 6.68914 7.51442 6.91695 7.74223L10.1754 11.0007L6.91728 14.2593Z"
            fill="#111827" />
        </svg>
      </span>
    </span>
    <span class="exctra-profile">
      <p class="first-line"><span>{{firstTwoWordofShortInfo}}</span> {{remainingWordsofShortInfo}}</p>
      <p class="second-line">{{showHowTo2["short-info-2"]}}</p>
    </span>
    <span class="min-deposits">
      <span>{{'Min Deposit'|translate}}</span>
      <span class="amount">₹ {{showHowTo2["minDeposit"].toLocaleString()}}</span>
    </span>
    <div class="home-page">
      <span class="center-home-icon">
        <img loading="lazy" src="../../../../assets/images/center-icon-progile-info.webp"
          style="width: 9.375rem; height: 9.375rem" alt="" />
      </span>
      <span class="text-start-info">
        <span>{{showHowTo2["bonusPercentage"]}}%</span> {{'of your deposit immediately goes to your main wallet as free money'|translate}}
      </span>
      <span class="text-info-2">
        {{'Claim'|translate}} <span>{{showHowTo2["bonusPercentage"]}}% {{'free'|translate}}</span> {{'money on every Deposite up to ₹'|translate}}
        {{showHowTo2["perMarketCap"].toLocaleString()}}
      </span>
      <span class="text-info-3"> {{'No Wagering required'|translate}} </span>
      <button (click)="closeInfoPage()">
        <span>{{'Get the bonus'|translate}}</span>
      </button>
      <span class="how-to-claim"> {{'How to claim the bonus?'|translate}} </span>
      <span class="answer-how-to-claim">
        {{'Make a desposite and get'|translate}} <span>{{showHowTo2["bonusPercentage"]}}% {{'free'|translate}}</span> {{'money immediatly in your'|translate}} <span>{{'main wallet'|translate}}</span>
      </span>
    </div>
  </div>
  <div style="position: relative; top:45rem; left:0; right:0; overflow-y: hidden;" [innerHTML]="htmlContent"></div>
</div>

<!-- Bonus card 2 -->
<app-how-to-bonus [bonus]="showHowTo" *ngIf="showHowTo" (closeClick)="showHowTo = false;"></app-how-to-bonus>

<!-- how to deposit video -->
<div class="Modal-Background-3 max-width-550" *ngIf="howToDeposit">
  <div class="video-player">
    <div class="close-img" (click)="closeVideoPopup()">
      <div class="skip-btn">
        <span>{{"Skip Video"|translate}}</span>
      </div>
    </div>
    <iframe class="video" src="https://player.vimeo.com/video/879781547?h=c26dd4d1c9&autoplay=1" frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
  </div>
</div>

<!--how to deposit hindi -->
<div class="Modal-Background-3 max-width-550" *ngIf="howToDepositHindi">
  <div class="video-player">
    <div class="close-img" (click)="closeVideoPopup()">
      <div class="skip-btn">
        <span>{{"Skip Video"|translate}}</span>
      </div>
    </div>
    <iframe class="video" src="https://player.vimeo.com/video/879783636?h=e6e764f594&autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
    <!-- <iframe class="video" src="https://player.vimeo.com/video/879783636?h=e6e764f594" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
    <!-- <iframe class="video" src="https://player.vimeo.com/video/879781547?h=c26dd4d1c9&autoplay=1" frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
  </div>
</div>

<!-- How to deposit lang popup -->
<div class="Modal-Background-5 Modal-Background max-width-550" *ngIf="howDepositLangPopup">
  <div class="loyalty-popup">
      <div class="loyalty-popup-card">
          <div class="close-image">
              <svg (click)="closeVideoPopup()" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                  viewBox="0 0 20 20" fill="none">
                  <path
                      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433288 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9969 7.34879 18.9423 4.80707 17.0676 2.93239C15.1929 1.0577 12.6512 0.0031277 10 0ZM13.8564 12.5718C13.9432 12.6557 14.0124 12.756 14.0601 12.8669C14.1077 12.9778 14.1328 13.0971 14.1339 13.2178C14.1349 13.3385 14.1119 13.4582 14.0662 13.57C14.0205 13.6817 13.953 13.7832 13.8676 13.8685C13.7823 13.9539 13.6808 14.0214 13.5691 14.0671C13.4573 14.1128 13.3376 14.1358 13.2169 14.1348C13.0962 14.1337 12.9769 14.1086 12.866 14.061C12.7551 14.0134 12.6548 13.9441 12.5709 13.8573L10 11.2855L7.42909 13.8573C7.25764 14.0229 7.028 14.1145 6.78964 14.1124C6.55128 14.1104 6.32327 14.0147 6.15471 13.8462C5.98616 13.6776 5.89055 13.4496 5.88848 13.2113C5.88641 12.9729 5.97804 12.7433 6.14364 12.5718L8.71455 10L6.14364 7.42818C6.05681 7.34432 5.98756 7.24401 5.93991 7.13309C5.89227 7.02218 5.86719 6.90289 5.86614 6.78218C5.86509 6.66147 5.88809 6.54176 5.9338 6.43004C5.97951 6.31832 6.04701 6.21681 6.13237 6.13146C6.21773 6.0461 6.31923 5.9786 6.43095 5.93289C6.54268 5.88718 6.66239 5.86418 6.78309 5.86523C6.9038 5.86627 7.02309 5.89135 7.13401 5.939C7.24492 5.98664 7.34523 6.0559 7.42909 6.14273L10 8.71454L12.5709 6.14273C12.6548 6.0559 12.7551 5.98664 12.866 5.939C12.9769 5.89135 13.0962 5.86627 13.2169 5.86523C13.3376 5.86418 13.4573 5.88718 13.5691 5.93289C13.6808 5.9786 13.7823 6.0461 13.8676 6.13146C13.953 6.21681 14.0205 6.31832 14.0662 6.43004C14.1119 6.54176 14.1349 6.66147 14.1339 6.78218C14.1328 6.90289 14.1077 7.02218 14.0601 7.13309C14.0124 7.24401 13.9432 7.34432 13.8564 7.42818L11.2855 10L13.8564 12.5718Z"
                      fill="#929EB5" />
              </svg>
          </div>
          <div class="select-lang">
            <span>{{'Select Language'|translate}}</span>
            <small>{{'Please choose the language that best suits your preference from the options below.'|translate}}</small>
          </div>
          <div class="lang-btn">
            <button (click)="englishVideoPopup()">English</button>
            <button (click)="hindiVideoPopup()">हिन्दी</button>
          </div>
      </div>
  </div>
</div>

<!--Update kyc popup-->
<!--<div class="Modal-Background-5 Modal-Background max-width-550" *ngIf="authservice.versionPopUpOpen">-->
<!--  <div class="kyc-popup">-->
<!--    <div class="rect-1"></div>-->
<!--    <div class="rect-2"></div>-->
<!--    <div class="rect-3"></div>-->
<!--      <div class="loyalty-popup-box">-->
<!--          <div class="close-image">-->
<!--              <svg (click)="closeKycPopup()" xmlns="http://www.w3.org/2000/svg" width="20" height="20"-->
<!--                  viewBox="0 0 20 20" fill="none">-->
<!--                  <path-->
<!--                      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433288 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9969 7.34879 18.9423 4.80707 17.0676 2.93239C15.1929 1.0577 12.6512 0.0031277 10 0ZM13.8564 12.5718C13.9432 12.6557 14.0124 12.756 14.0601 12.8669C14.1077 12.9778 14.1328 13.0971 14.1339 13.2178C14.1349 13.3385 14.1119 13.4582 14.0662 13.57C14.0205 13.6817 13.953 13.7832 13.8676 13.8685C13.7823 13.9539 13.6808 14.0214 13.5691 14.0671C13.4573 14.1128 13.3376 14.1358 13.2169 14.1348C13.0962 14.1337 12.9769 14.1086 12.866 14.061C12.7551 14.0134 12.6548 13.9441 12.5709 13.8573L10 11.2855L7.42909 13.8573C7.25764 14.0229 7.028 14.1145 6.78964 14.1124C6.55128 14.1104 6.32327 14.0147 6.15471 13.8462C5.98616 13.6776 5.89055 13.4496 5.88848 13.2113C5.88641 12.9729 5.97804 12.7433 6.14364 12.5718L8.71455 10L6.14364 7.42818C6.05681 7.34432 5.98756 7.24401 5.93991 7.13309C5.89227 7.02218 5.86719 6.90289 5.86614 6.78218C5.86509 6.66147 5.88809 6.54176 5.9338 6.43004C5.97951 6.31832 6.04701 6.21681 6.13237 6.13146C6.21773 6.0461 6.31923 5.9786 6.43095 5.93289C6.54268 5.88718 6.66239 5.86418 6.78309 5.86523C6.9038 5.86627 7.02309 5.89135 7.13401 5.939C7.24492 5.98664 7.34523 6.0559 7.42909 6.14273L10 8.71454L12.5709 6.14273C12.6548 6.0559 12.7551 5.98664 12.866 5.939C12.9769 5.89135 13.0962 5.86627 13.2169 5.86523C13.3376 5.86418 13.4573 5.88718 13.5691 5.93289C13.6808 5.9786 13.7823 6.0461 13.8676 6.13146C13.953 6.21681 14.0205 6.31832 14.0662 6.43004C14.1119 6.54176 14.1349 6.66147 14.1339 6.78218C14.1328 6.90289 14.1077 7.02218 14.0601 7.13309C14.0124 7.24401 13.9432 7.34432 13.8564 7.42818L11.2855 10L13.8564 12.5718Z"-->
<!--                      fill="#929EB5" />-->
<!--              </svg>-->
<!--          </div>-->
<!--          <div class="kyc-content">-->
<!--            <span>Please update your KYC in order to proceed your withdrawal</span>-->
<!--            <span style="font-size: 16px;">If already done ignore this pop-up</span>-->
<!--          </div>-->
<!--          <div class="lang-btn intercom">-->
<!--            <button class="kyc-btn" (click)="clickOpenIntercom()">Update KYC</button>-->
<!--          </div>-->
<!--      </div>-->
<!--  </div>-->
<!--</div>-->
